/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigDecimal: { input: string; output: string; }
  BigInt: { input: string; output: string; }
  Bytes: { input: string; output: string; }
  /**
   * 8 bytes signed integer
   *
   */
  Int8: { input: number; output: number; }
  /**
   * A string representation of microseconds UNIX timestamp (16 digits)
   *
   */
  Timestamp: { input: number; output: number; }
};

export enum AggregationInterval {
  Day = 'day',
  Hour = 'hour'
}

export type AssetToken = {
  __typename?: 'AssetToken';
  ONE: Scalars['BigDecimal']['output'];
  agents: Array<Scalars['Bytes']['output']>;
  /** AssetTokenData contract */
  assetTokenData: AssetTokenData;
  /** Each one is a contract with the isTxAuthorized function */
  authorizationList: Array<Scalars['Bytes']['output']>;
  blacklist: Array<Scalars['Bytes']['output']>;
  /** Certain addresses that can transfer even on safeguard */
  canTransferOnSafeGuard: Array<Scalars['Bytes']['output']>;
  /** Decimals of the AssetToken */
  decimals: Scalars['Int']['output'];
  /** Value from AssetTokenFactory state */
  enabled: Scalars['Boolean']['output'];
  /** Factory that was used to deploy current AssetToken */
  factory: AssetTokenFactory;
  frozen: Scalars['Boolean']['output'];
  guardian: Scalars['Bytes']['output'];
  /** Address of AssetToken */
  id: Scalars['ID']['output'];
  isOnSafeGuard: Scalars['Boolean']['output'];
  issuer?: Maybe<AssetTokenIssuer>;
  /** know your asset string */
  kya: Scalars['String']['output'];
  /** Data from the ipfs path specified in kya property */
  kyaData?: Maybe<KyaData>;
  /** The value is in percent per seconds, 20 digits */
  lastInterestRate: Scalars['BigInt']['output'];
  /** Last block where the update function was called */
  lastUpdate: Scalars['Int']['output'];
  /** minimum Redemption Amount (in Asset token value) */
  minimumRedemptionAmount: Scalars['BigDecimal']['output'];
  /** Name of the AssetToken */
  name: Scalars['String']['output'];
  /** If the interest will be a positvie or negative one */
  positiveInterest: Scalars['Boolean']['output'];
  /** Exchange Rate */
  rate: Scalars['BigDecimal']['output'];
  /** if this gets overgrown the contract change state, [0.01 - 1] */
  statePercent: Scalars['BigDecimal']['output'];
  /** Symbol of the AssetToken */
  symbol: Scalars['String']['output'];
  type: AssetTokenType;
};

export type AssetTokenData = {
  __typename?: 'AssetTokenData';
  assetTokens?: Maybe<Array<AssetToken>>;
  id: Scalars['ID']['output'];
};


export type AssetTokenDataAssetTokensArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AssetTokenOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetTokenFilter>;
};

export type AssetTokenDataFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<AssetTokenDataFilter>>>;
  assetTokens_?: InputMaybe<AssetTokenFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<AssetTokenDataFilter>>>;
};

export enum AssetTokenDataOrderBy {
  AssetTokens = 'assetTokens',
  Id = 'id'
}

export type AssetTokenFactory = {
  __typename?: 'AssetTokenFactory';
  /** The address of AssetTokenData contract */
  assetTokenData: AssetTokenData;
  /** All AssetTokens deployed with this factory */
  assetTokens?: Maybe<Array<AssetToken>>;
  /** Number of AssetTokens that were deployed by this factory */
  assetTokensCount: Scalars['Int']['output'];
  /** The address of AssetTokenFactory contract */
  id: Scalars['ID']['output'];
};


export type AssetTokenFactoryAssetTokensArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AssetTokenOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetTokenFilter>;
};

export type AssetTokenFactoryFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<AssetTokenFactoryFilter>>>;
  assetTokenData?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_?: InputMaybe<AssetTokenDataFilter>;
  assetTokenData_contains?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_ends_with?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_gt?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_gte?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_in?: InputMaybe<Array<Scalars['String']['input']>>;
  assetTokenData_lt?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_lte?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_not?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_not_contains?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  assetTokenData_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_starts_with?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  assetTokensCount?: InputMaybe<Scalars['Int']['input']>;
  assetTokensCount_gt?: InputMaybe<Scalars['Int']['input']>;
  assetTokensCount_gte?: InputMaybe<Scalars['Int']['input']>;
  assetTokensCount_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  assetTokensCount_lt?: InputMaybe<Scalars['Int']['input']>;
  assetTokensCount_lte?: InputMaybe<Scalars['Int']['input']>;
  assetTokensCount_not?: InputMaybe<Scalars['Int']['input']>;
  assetTokensCount_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  assetTokens_?: InputMaybe<AssetTokenFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<AssetTokenFactoryFilter>>>;
};

export enum AssetTokenFactoryOrderBy {
  AssetTokenData = 'assetTokenData',
  AssetTokenDataId = 'assetTokenData__id',
  AssetTokens = 'assetTokens',
  AssetTokensCount = 'assetTokensCount',
  Id = 'id'
}

export type AssetTokenIssuer = {
  __typename?: 'AssetTokenIssuer';
  assetToken: AssetToken;
  /** Assets are allowed to use in mint function of the AssetToken as a payment token. */
  authorizedAssets: Array<Scalars['Bytes']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AssetTokenIssuerFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<AssetTokenIssuerFilter>>>;
  assetToken?: InputMaybe<Scalars['String']['input']>;
  assetToken_?: InputMaybe<AssetTokenFilter>;
  assetToken_contains?: InputMaybe<Scalars['String']['input']>;
  assetToken_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  assetToken_ends_with?: InputMaybe<Scalars['String']['input']>;
  assetToken_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  assetToken_gt?: InputMaybe<Scalars['String']['input']>;
  assetToken_gte?: InputMaybe<Scalars['String']['input']>;
  assetToken_in?: InputMaybe<Array<Scalars['String']['input']>>;
  assetToken_lt?: InputMaybe<Scalars['String']['input']>;
  assetToken_lte?: InputMaybe<Scalars['String']['input']>;
  assetToken_not?: InputMaybe<Scalars['String']['input']>;
  assetToken_not_contains?: InputMaybe<Scalars['String']['input']>;
  assetToken_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  assetToken_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  assetToken_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  assetToken_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  assetToken_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  assetToken_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  assetToken_starts_with?: InputMaybe<Scalars['String']['input']>;
  assetToken_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  authorizedAssets?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  authorizedAssets_contains?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  authorizedAssets_contains_nocase?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  authorizedAssets_not?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  authorizedAssets_not_contains?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  authorizedAssets_not_contains_nocase?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<AssetTokenIssuerFilter>>>;
};

export enum AssetTokenIssuerOrderBy {
  AssetToken = 'assetToken',
  AssetTokenOne = 'assetToken__ONE',
  AssetTokenDecimals = 'assetToken__decimals',
  AssetTokenEnabled = 'assetToken__enabled',
  AssetTokenFrozen = 'assetToken__frozen',
  AssetTokenGuardian = 'assetToken__guardian',
  AssetTokenId = 'assetToken__id',
  AssetTokenIsOnSafeGuard = 'assetToken__isOnSafeGuard',
  AssetTokenKya = 'assetToken__kya',
  AssetTokenLastInterestRate = 'assetToken__lastInterestRate',
  AssetTokenLastUpdate = 'assetToken__lastUpdate',
  AssetTokenMinimumRedemptionAmount = 'assetToken__minimumRedemptionAmount',
  AssetTokenName = 'assetToken__name',
  AssetTokenPositiveInterest = 'assetToken__positiveInterest',
  AssetTokenRate = 'assetToken__rate',
  AssetTokenStatePercent = 'assetToken__statePercent',
  AssetTokenSymbol = 'assetToken__symbol',
  AssetTokenType = 'assetToken__type',
  AuthorizedAssets = 'authorizedAssets',
  Id = 'id',
  Name = 'name'
}

export enum AssetTokenType {
  Bond = 'bond',
  Index = 'index',
  LiquidStaking = 'liquidStaking',
  Stock = 'stock',
  Unknown = 'unknown'
}

export type AssetTokenFilter = {
  ONE?: InputMaybe<Scalars['BigDecimal']['input']>;
  ONE_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  ONE_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  ONE_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  ONE_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  ONE_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  ONE_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  ONE_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  agents?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  agents_contains?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  agents_contains_nocase?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  agents_not?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  agents_not_contains?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  agents_not_contains_nocase?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  and?: InputMaybe<Array<InputMaybe<AssetTokenFilter>>>;
  assetTokenData?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_?: InputMaybe<AssetTokenDataFilter>;
  assetTokenData_contains?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_ends_with?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_gt?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_gte?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_in?: InputMaybe<Array<Scalars['String']['input']>>;
  assetTokenData_lt?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_lte?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_not?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_not_contains?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  assetTokenData_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_starts_with?: InputMaybe<Scalars['String']['input']>;
  assetTokenData_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  authorizationList?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  authorizationList_contains?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  authorizationList_contains_nocase?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  authorizationList_not?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  authorizationList_not_contains?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  authorizationList_not_contains_nocase?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  blacklist?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  blacklist_contains?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  blacklist_contains_nocase?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  blacklist_not?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  blacklist_not_contains?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  blacklist_not_contains_nocase?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  canTransferOnSafeGuard?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  canTransferOnSafeGuard_contains?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  canTransferOnSafeGuard_contains_nocase?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  canTransferOnSafeGuard_not?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  canTransferOnSafeGuard_not_contains?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  canTransferOnSafeGuard_not_contains_nocase?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  decimals?: InputMaybe<Scalars['Int']['input']>;
  decimals_gt?: InputMaybe<Scalars['Int']['input']>;
  decimals_gte?: InputMaybe<Scalars['Int']['input']>;
  decimals_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  decimals_lt?: InputMaybe<Scalars['Int']['input']>;
  decimals_lte?: InputMaybe<Scalars['Int']['input']>;
  decimals_not?: InputMaybe<Scalars['Int']['input']>;
  decimals_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabled_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  enabled_not?: InputMaybe<Scalars['Boolean']['input']>;
  enabled_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  factory?: InputMaybe<Scalars['String']['input']>;
  factory_?: InputMaybe<AssetTokenFactoryFilter>;
  factory_contains?: InputMaybe<Scalars['String']['input']>;
  factory_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  factory_ends_with?: InputMaybe<Scalars['String']['input']>;
  factory_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  factory_gt?: InputMaybe<Scalars['String']['input']>;
  factory_gte?: InputMaybe<Scalars['String']['input']>;
  factory_in?: InputMaybe<Array<Scalars['String']['input']>>;
  factory_lt?: InputMaybe<Scalars['String']['input']>;
  factory_lte?: InputMaybe<Scalars['String']['input']>;
  factory_not?: InputMaybe<Scalars['String']['input']>;
  factory_not_contains?: InputMaybe<Scalars['String']['input']>;
  factory_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  factory_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  factory_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  factory_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  factory_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  factory_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  factory_starts_with?: InputMaybe<Scalars['String']['input']>;
  factory_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  frozen?: InputMaybe<Scalars['Boolean']['input']>;
  frozen_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  frozen_not?: InputMaybe<Scalars['Boolean']['input']>;
  frozen_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  guardian?: InputMaybe<Scalars['Bytes']['input']>;
  guardian_contains?: InputMaybe<Scalars['Bytes']['input']>;
  guardian_gt?: InputMaybe<Scalars['Bytes']['input']>;
  guardian_gte?: InputMaybe<Scalars['Bytes']['input']>;
  guardian_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  guardian_lt?: InputMaybe<Scalars['Bytes']['input']>;
  guardian_lte?: InputMaybe<Scalars['Bytes']['input']>;
  guardian_not?: InputMaybe<Scalars['Bytes']['input']>;
  guardian_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  guardian_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isOnSafeGuard?: InputMaybe<Scalars['Boolean']['input']>;
  isOnSafeGuard_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isOnSafeGuard_not?: InputMaybe<Scalars['Boolean']['input']>;
  isOnSafeGuard_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  issuer?: InputMaybe<Scalars['String']['input']>;
  issuer_?: InputMaybe<AssetTokenIssuerFilter>;
  issuer_contains?: InputMaybe<Scalars['String']['input']>;
  issuer_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  issuer_ends_with?: InputMaybe<Scalars['String']['input']>;
  issuer_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  issuer_gt?: InputMaybe<Scalars['String']['input']>;
  issuer_gte?: InputMaybe<Scalars['String']['input']>;
  issuer_in?: InputMaybe<Array<Scalars['String']['input']>>;
  issuer_lt?: InputMaybe<Scalars['String']['input']>;
  issuer_lte?: InputMaybe<Scalars['String']['input']>;
  issuer_not?: InputMaybe<Scalars['String']['input']>;
  issuer_not_contains?: InputMaybe<Scalars['String']['input']>;
  issuer_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  issuer_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  issuer_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  issuer_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  issuer_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  issuer_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  issuer_starts_with?: InputMaybe<Scalars['String']['input']>;
  issuer_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  kya?: InputMaybe<Scalars['String']['input']>;
  kyaData?: InputMaybe<Scalars['String']['input']>;
  kyaData_?: InputMaybe<KyaDataFilter>;
  kyaData_contains?: InputMaybe<Scalars['String']['input']>;
  kyaData_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  kyaData_ends_with?: InputMaybe<Scalars['String']['input']>;
  kyaData_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  kyaData_gt?: InputMaybe<Scalars['String']['input']>;
  kyaData_gte?: InputMaybe<Scalars['String']['input']>;
  kyaData_in?: InputMaybe<Array<Scalars['String']['input']>>;
  kyaData_lt?: InputMaybe<Scalars['String']['input']>;
  kyaData_lte?: InputMaybe<Scalars['String']['input']>;
  kyaData_not?: InputMaybe<Scalars['String']['input']>;
  kyaData_not_contains?: InputMaybe<Scalars['String']['input']>;
  kyaData_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  kyaData_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  kyaData_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  kyaData_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  kyaData_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  kyaData_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  kyaData_starts_with?: InputMaybe<Scalars['String']['input']>;
  kyaData_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  kya_contains?: InputMaybe<Scalars['String']['input']>;
  kya_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  kya_ends_with?: InputMaybe<Scalars['String']['input']>;
  kya_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  kya_gt?: InputMaybe<Scalars['String']['input']>;
  kya_gte?: InputMaybe<Scalars['String']['input']>;
  kya_in?: InputMaybe<Array<Scalars['String']['input']>>;
  kya_lt?: InputMaybe<Scalars['String']['input']>;
  kya_lte?: InputMaybe<Scalars['String']['input']>;
  kya_not?: InputMaybe<Scalars['String']['input']>;
  kya_not_contains?: InputMaybe<Scalars['String']['input']>;
  kya_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  kya_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  kya_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  kya_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  kya_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  kya_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  kya_starts_with?: InputMaybe<Scalars['String']['input']>;
  kya_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  lastInterestRate?: InputMaybe<Scalars['BigInt']['input']>;
  lastInterestRate_gt?: InputMaybe<Scalars['BigInt']['input']>;
  lastInterestRate_gte?: InputMaybe<Scalars['BigInt']['input']>;
  lastInterestRate_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lastInterestRate_lt?: InputMaybe<Scalars['BigInt']['input']>;
  lastInterestRate_lte?: InputMaybe<Scalars['BigInt']['input']>;
  lastInterestRate_not?: InputMaybe<Scalars['BigInt']['input']>;
  lastInterestRate_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lastUpdate?: InputMaybe<Scalars['Int']['input']>;
  lastUpdate_gt?: InputMaybe<Scalars['Int']['input']>;
  lastUpdate_gte?: InputMaybe<Scalars['Int']['input']>;
  lastUpdate_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lastUpdate_lt?: InputMaybe<Scalars['Int']['input']>;
  lastUpdate_lte?: InputMaybe<Scalars['Int']['input']>;
  lastUpdate_not?: InputMaybe<Scalars['Int']['input']>;
  lastUpdate_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  minimumRedemptionAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
  minimumRedemptionAmount_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  minimumRedemptionAmount_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  minimumRedemptionAmount_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  minimumRedemptionAmount_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  minimumRedemptionAmount_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  minimumRedemptionAmount_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  minimumRedemptionAmount_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<AssetTokenFilter>>>;
  positiveInterest?: InputMaybe<Scalars['Boolean']['input']>;
  positiveInterest_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  positiveInterest_not?: InputMaybe<Scalars['Boolean']['input']>;
  positiveInterest_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  rate?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  rate_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  rate_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  statePercent?: InputMaybe<Scalars['BigDecimal']['input']>;
  statePercent_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  statePercent_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  statePercent_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  statePercent_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  statePercent_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  statePercent_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  statePercent_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  symbol_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_gt?: InputMaybe<Scalars['String']['input']>;
  symbol_gte?: InputMaybe<Scalars['String']['input']>;
  symbol_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_lt?: InputMaybe<Scalars['String']['input']>;
  symbol_lte?: InputMaybe<Scalars['String']['input']>;
  symbol_not?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AssetTokenType>;
  type_in?: InputMaybe<Array<AssetTokenType>>;
  type_not?: InputMaybe<AssetTokenType>;
  type_not_in?: InputMaybe<Array<AssetTokenType>>;
};

export enum AssetTokenOrderBy {
  One = 'ONE',
  Agents = 'agents',
  AssetTokenData = 'assetTokenData',
  AssetTokenDataId = 'assetTokenData__id',
  AuthorizationList = 'authorizationList',
  Blacklist = 'blacklist',
  CanTransferOnSafeGuard = 'canTransferOnSafeGuard',
  Decimals = 'decimals',
  Enabled = 'enabled',
  Factory = 'factory',
  FactoryAssetTokensCount = 'factory__assetTokensCount',
  FactoryId = 'factory__id',
  Frozen = 'frozen',
  Guardian = 'guardian',
  Id = 'id',
  IsOnSafeGuard = 'isOnSafeGuard',
  Issuer = 'issuer',
  IssuerId = 'issuer__id',
  IssuerName = 'issuer__name',
  Kya = 'kya',
  KyaData = 'kyaData',
  KyaDataAssetType = 'kyaData__assetType',
  KyaDataBlockchain = 'kyaData__blockchain',
  KyaDataDescription = 'kyaData__description',
  KyaDataExternalUrl = 'kyaData__externalUrl',
  KyaDataId = 'kyaData__id',
  KyaDataImage = 'kyaData__image',
  KyaDataName = 'kyaData__name',
  KyaDataRedemptionAsset = 'kyaData__redemptionAsset',
  KyaDataSymbol = 'kyaData__symbol',
  KyaDataUnderlyingAsset = 'kyaData__underlyingAsset',
  KyaDataUnderlyingAssetBlockchain = 'kyaData__underlyingAssetBlockchain',
  LastInterestRate = 'lastInterestRate',
  LastUpdate = 'lastUpdate',
  MinimumRedemptionAmount = 'minimumRedemptionAmount',
  Name = 'name',
  PositiveInterest = 'positiveInterest',
  Rate = 'rate',
  StatePercent = 'statePercent',
  Symbol = 'symbol',
  Type = 'type'
}

export type Balancer = {
  __typename?: 'Balancer';
  color: Scalars['String']['output'];
  crpControllerCount?: Maybe<Array<CrpControllerPoolCount>>;
  crpCount: Scalars['Int']['output'];
  finalizedPoolCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  poolCount: Scalars['Int']['output'];
  pools?: Maybe<Array<Pool>>;
  privateCount: Scalars['Int']['output'];
  totalLiquidity: Scalars['BigDecimal']['output'];
  totalSwapFee: Scalars['BigDecimal']['output'];
  totalSwapVolume: Scalars['BigDecimal']['output'];
  txCount: Scalars['BigInt']['output'];
};


export type BalancerCrpControllerCountArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CrpControllerPoolCountOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CrpControllerPoolCountFilter>;
};


export type BalancerPoolsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PoolFilter>;
};

export type BalancerFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<BalancerFilter>>>;
  color?: InputMaybe<Scalars['String']['input']>;
  color_contains?: InputMaybe<Scalars['String']['input']>;
  color_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  color_ends_with?: InputMaybe<Scalars['String']['input']>;
  color_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  color_gt?: InputMaybe<Scalars['String']['input']>;
  color_gte?: InputMaybe<Scalars['String']['input']>;
  color_in?: InputMaybe<Array<Scalars['String']['input']>>;
  color_lt?: InputMaybe<Scalars['String']['input']>;
  color_lte?: InputMaybe<Scalars['String']['input']>;
  color_not?: InputMaybe<Scalars['String']['input']>;
  color_not_contains?: InputMaybe<Scalars['String']['input']>;
  color_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  color_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  color_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  color_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  color_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  color_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  color_starts_with?: InputMaybe<Scalars['String']['input']>;
  color_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  crpControllerCount_?: InputMaybe<CrpControllerPoolCountFilter>;
  crpCount?: InputMaybe<Scalars['Int']['input']>;
  crpCount_gt?: InputMaybe<Scalars['Int']['input']>;
  crpCount_gte?: InputMaybe<Scalars['Int']['input']>;
  crpCount_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  crpCount_lt?: InputMaybe<Scalars['Int']['input']>;
  crpCount_lte?: InputMaybe<Scalars['Int']['input']>;
  crpCount_not?: InputMaybe<Scalars['Int']['input']>;
  crpCount_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  finalizedPoolCount?: InputMaybe<Scalars['Int']['input']>;
  finalizedPoolCount_gt?: InputMaybe<Scalars['Int']['input']>;
  finalizedPoolCount_gte?: InputMaybe<Scalars['Int']['input']>;
  finalizedPoolCount_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  finalizedPoolCount_lt?: InputMaybe<Scalars['Int']['input']>;
  finalizedPoolCount_lte?: InputMaybe<Scalars['Int']['input']>;
  finalizedPoolCount_not?: InputMaybe<Scalars['Int']['input']>;
  finalizedPoolCount_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<BalancerFilter>>>;
  poolCount?: InputMaybe<Scalars['Int']['input']>;
  poolCount_gt?: InputMaybe<Scalars['Int']['input']>;
  poolCount_gte?: InputMaybe<Scalars['Int']['input']>;
  poolCount_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  poolCount_lt?: InputMaybe<Scalars['Int']['input']>;
  poolCount_lte?: InputMaybe<Scalars['Int']['input']>;
  poolCount_not?: InputMaybe<Scalars['Int']['input']>;
  poolCount_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  pools_?: InputMaybe<PoolFilter>;
  privateCount?: InputMaybe<Scalars['Int']['input']>;
  privateCount_gt?: InputMaybe<Scalars['Int']['input']>;
  privateCount_gte?: InputMaybe<Scalars['Int']['input']>;
  privateCount_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  privateCount_lt?: InputMaybe<Scalars['Int']['input']>;
  privateCount_lte?: InputMaybe<Scalars['Int']['input']>;
  privateCount_not?: InputMaybe<Scalars['Int']['input']>;
  privateCount_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  totalLiquidity?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalLiquidity_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalLiquidity_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalLiquidity_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalLiquidity_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalLiquidity_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalLiquidity_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalLiquidity_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalSwapFee?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalSwapFee_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalSwapFee_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalSwapFee_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalSwapFee_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalSwapFee_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalSwapFee_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalSwapFee_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalSwapVolume?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalSwapVolume_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalSwapVolume_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalSwapVolume_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalSwapVolume_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalSwapVolume_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalSwapVolume_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalSwapVolume_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  txCount?: InputMaybe<Scalars['BigInt']['input']>;
  txCount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  txCount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  txCount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  txCount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  txCount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  txCount_not?: InputMaybe<Scalars['BigInt']['input']>;
  txCount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum BalancerOrderBy {
  Color = 'color',
  CrpControllerCount = 'crpControllerCount',
  CrpCount = 'crpCount',
  FinalizedPoolCount = 'finalizedPoolCount',
  Id = 'id',
  PoolCount = 'poolCount',
  Pools = 'pools',
  PrivateCount = 'privateCount',
  TotalLiquidity = 'totalLiquidity',
  TotalSwapFee = 'totalSwapFee',
  TotalSwapVolume = 'totalSwapVolume',
  TxCount = 'txCount'
}

export type BlockChangedFilter = {
  number_gte: Scalars['Int']['input'];
};

export type BlockHeight = {
  hash?: InputMaybe<Scalars['Bytes']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  number_gte?: InputMaybe<Scalars['Int']['input']>;
};

export type CrPool = {
  __typename?: 'CRPool';
  bPool: Pool;
  id: Scalars['ID']['output'];
};

export type CrPoolGradualWeightsUpdate = {
  __typename?: 'CRPoolGradualWeightsUpdate';
  endBlock: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  newWeights: Array<Scalars['BigInt']['output']>;
  pool: Pool;
  startBlock: Scalars['BigInt']['output'];
};

export type CrPoolGradualWeightsUpdateFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<CrPoolGradualWeightsUpdateFilter>>>;
  endBlock?: InputMaybe<Scalars['BigInt']['input']>;
  endBlock_gt?: InputMaybe<Scalars['BigInt']['input']>;
  endBlock_gte?: InputMaybe<Scalars['BigInt']['input']>;
  endBlock_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  endBlock_lt?: InputMaybe<Scalars['BigInt']['input']>;
  endBlock_lte?: InputMaybe<Scalars['BigInt']['input']>;
  endBlock_not?: InputMaybe<Scalars['BigInt']['input']>;
  endBlock_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  newWeights?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  newWeights_contains?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  newWeights_contains_nocase?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  newWeights_not?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  newWeights_not_contains?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  newWeights_not_contains_nocase?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<CrPoolGradualWeightsUpdateFilter>>>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_?: InputMaybe<PoolFilter>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  startBlock?: InputMaybe<Scalars['BigInt']['input']>;
  startBlock_gt?: InputMaybe<Scalars['BigInt']['input']>;
  startBlock_gte?: InputMaybe<Scalars['BigInt']['input']>;
  startBlock_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  startBlock_lt?: InputMaybe<Scalars['BigInt']['input']>;
  startBlock_lte?: InputMaybe<Scalars['BigInt']['input']>;
  startBlock_not?: InputMaybe<Scalars['BigInt']['input']>;
  startBlock_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export enum CrPoolGradualWeightsUpdateOrderBy {
  EndBlock = 'endBlock',
  Id = 'id',
  NewWeights = 'newWeights',
  Pool = 'pool',
  PoolActive = 'pool__active',
  PoolAddTokenTimeLockInBlocks = 'pool__addTokenTimeLockInBlocks',
  PoolCap = 'pool__cap',
  PoolController = 'pool__controller',
  PoolCreateTime = 'pool__createTime',
  PoolCrp = 'pool__crp',
  PoolCrpController = 'pool__crpController',
  PoolExitsCount = 'pool__exitsCount',
  PoolFinalized = 'pool__finalized',
  PoolHoldersCount = 'pool__holdersCount',
  PoolId = 'pool__id',
  PoolJoinsCount = 'pool__joinsCount',
  PoolLiquidity = 'pool__liquidity',
  PoolLogAddress = 'pool__logAddress',
  PoolMinimumWeightChangeBlockPeriod = 'pool__minimumWeightChangeBlockPeriod',
  PoolName = 'pool__name',
  PoolPublicSwap = 'pool__publicSwap',
  PoolSwapFee = 'pool__swapFee',
  PoolSwapsCount = 'pool__swapsCount',
  PoolSymbol = 'pool__symbol',
  PoolTokensCount = 'pool__tokensCount',
  PoolTotalShares = 'pool__totalShares',
  PoolTotalSwapFee = 'pool__totalSwapFee',
  PoolTotalSwapVolume = 'pool__totalSwapVolume',
  PoolTotalWeight = 'pool__totalWeight',
  PoolTx = 'pool__tx',
  StartBlock = 'startBlock'
}

export type CrPoolFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<CrPoolFilter>>>;
  bPool?: InputMaybe<Scalars['String']['input']>;
  bPool_?: InputMaybe<PoolFilter>;
  bPool_contains?: InputMaybe<Scalars['String']['input']>;
  bPool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  bPool_ends_with?: InputMaybe<Scalars['String']['input']>;
  bPool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  bPool_gt?: InputMaybe<Scalars['String']['input']>;
  bPool_gte?: InputMaybe<Scalars['String']['input']>;
  bPool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  bPool_lt?: InputMaybe<Scalars['String']['input']>;
  bPool_lte?: InputMaybe<Scalars['String']['input']>;
  bPool_not?: InputMaybe<Scalars['String']['input']>;
  bPool_not_contains?: InputMaybe<Scalars['String']['input']>;
  bPool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  bPool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  bPool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  bPool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  bPool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  bPool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  bPool_starts_with?: InputMaybe<Scalars['String']['input']>;
  bPool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<CrPoolFilter>>>;
};

export enum CrPoolOrderBy {
  BPool = 'bPool',
  BPoolActive = 'bPool__active',
  BPoolAddTokenTimeLockInBlocks = 'bPool__addTokenTimeLockInBlocks',
  BPoolCap = 'bPool__cap',
  BPoolController = 'bPool__controller',
  BPoolCreateTime = 'bPool__createTime',
  BPoolCrp = 'bPool__crp',
  BPoolCrpController = 'bPool__crpController',
  BPoolExitsCount = 'bPool__exitsCount',
  BPoolFinalized = 'bPool__finalized',
  BPoolHoldersCount = 'bPool__holdersCount',
  BPoolId = 'bPool__id',
  BPoolJoinsCount = 'bPool__joinsCount',
  BPoolLiquidity = 'bPool__liquidity',
  BPoolLogAddress = 'bPool__logAddress',
  BPoolMinimumWeightChangeBlockPeriod = 'bPool__minimumWeightChangeBlockPeriod',
  BPoolName = 'bPool__name',
  BPoolPublicSwap = 'bPool__publicSwap',
  BPoolSwapFee = 'bPool__swapFee',
  BPoolSwapsCount = 'bPool__swapsCount',
  BPoolSymbol = 'bPool__symbol',
  BPoolTokensCount = 'bPool__tokensCount',
  BPoolTotalShares = 'bPool__totalShares',
  BPoolTotalSwapFee = 'bPool__totalSwapFee',
  BPoolTotalSwapVolume = 'bPool__totalSwapVolume',
  BPoolTotalWeight = 'bPool__totalWeight',
  BPoolTx = 'bPool__tx',
  Id = 'id'
}

export type CrpControllerPoolCount = {
  __typename?: 'CrpControllerPoolCount';
  factoryID: Balancer;
  id: Scalars['ID']['output'];
  poolCount: Scalars['Int']['output'];
};

export type CrpControllerPoolCountFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<CrpControllerPoolCountFilter>>>;
  factoryID?: InputMaybe<Scalars['String']['input']>;
  factoryID_?: InputMaybe<BalancerFilter>;
  factoryID_contains?: InputMaybe<Scalars['String']['input']>;
  factoryID_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  factoryID_ends_with?: InputMaybe<Scalars['String']['input']>;
  factoryID_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  factoryID_gt?: InputMaybe<Scalars['String']['input']>;
  factoryID_gte?: InputMaybe<Scalars['String']['input']>;
  factoryID_in?: InputMaybe<Array<Scalars['String']['input']>>;
  factoryID_lt?: InputMaybe<Scalars['String']['input']>;
  factoryID_lte?: InputMaybe<Scalars['String']['input']>;
  factoryID_not?: InputMaybe<Scalars['String']['input']>;
  factoryID_not_contains?: InputMaybe<Scalars['String']['input']>;
  factoryID_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  factoryID_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  factoryID_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  factoryID_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  factoryID_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  factoryID_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  factoryID_starts_with?: InputMaybe<Scalars['String']['input']>;
  factoryID_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<CrpControllerPoolCountFilter>>>;
  poolCount?: InputMaybe<Scalars['Int']['input']>;
  poolCount_gt?: InputMaybe<Scalars['Int']['input']>;
  poolCount_gte?: InputMaybe<Scalars['Int']['input']>;
  poolCount_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  poolCount_lt?: InputMaybe<Scalars['Int']['input']>;
  poolCount_lte?: InputMaybe<Scalars['Int']['input']>;
  poolCount_not?: InputMaybe<Scalars['Int']['input']>;
  poolCount_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum CrpControllerPoolCountOrderBy {
  FactoryId = 'factoryID',
  FactoryIdColor = 'factoryID__color',
  FactoryIdCrpCount = 'factoryID__crpCount',
  FactoryIdFinalizedPoolCount = 'factoryID__finalizedPoolCount',
  FactoryIdId = 'factoryID__id',
  FactoryIdPoolCount = 'factoryID__poolCount',
  FactoryIdPrivateCount = 'factoryID__privateCount',
  FactoryIdTotalLiquidity = 'factoryID__totalLiquidity',
  FactoryIdTotalSwapFee = 'factoryID__totalSwapFee',
  FactoryIdTotalSwapVolume = 'factoryID__totalSwapVolume',
  FactoryIdTxCount = 'factoryID__txCount',
  Id = 'id',
  PoolCount = 'poolCount'
}

export type DotcAsset = {
  __typename?: 'DOTCAsset';
  address: Scalars['String']['output'];
  assetType: Scalars['Int']['output'];
  decimals: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  tokenId?: Maybe<Scalars['Int']['output']>;
};

export type DotcAssetFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  address?: InputMaybe<Scalars['String']['input']>;
  address_contains?: InputMaybe<Scalars['String']['input']>;
  address_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  address_ends_with?: InputMaybe<Scalars['String']['input']>;
  address_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  address_gt?: InputMaybe<Scalars['String']['input']>;
  address_gte?: InputMaybe<Scalars['String']['input']>;
  address_in?: InputMaybe<Array<Scalars['String']['input']>>;
  address_lt?: InputMaybe<Scalars['String']['input']>;
  address_lte?: InputMaybe<Scalars['String']['input']>;
  address_not?: InputMaybe<Scalars['String']['input']>;
  address_not_contains?: InputMaybe<Scalars['String']['input']>;
  address_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  address_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  address_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  address_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  address_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  address_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  address_starts_with?: InputMaybe<Scalars['String']['input']>;
  address_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  and?: InputMaybe<Array<InputMaybe<DotcAssetFilter>>>;
  assetType?: InputMaybe<Scalars['Int']['input']>;
  assetType_gt?: InputMaybe<Scalars['Int']['input']>;
  assetType_gte?: InputMaybe<Scalars['Int']['input']>;
  assetType_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  assetType_lt?: InputMaybe<Scalars['Int']['input']>;
  assetType_lte?: InputMaybe<Scalars['Int']['input']>;
  assetType_not?: InputMaybe<Scalars['Int']['input']>;
  assetType_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  decimals?: InputMaybe<Scalars['Int']['input']>;
  decimals_gt?: InputMaybe<Scalars['Int']['input']>;
  decimals_gte?: InputMaybe<Scalars['Int']['input']>;
  decimals_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  decimals_lt?: InputMaybe<Scalars['Int']['input']>;
  decimals_lte?: InputMaybe<Scalars['Int']['input']>;
  decimals_not?: InputMaybe<Scalars['Int']['input']>;
  decimals_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<DotcAssetFilter>>>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  symbol_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_gt?: InputMaybe<Scalars['String']['input']>;
  symbol_gte?: InputMaybe<Scalars['String']['input']>;
  symbol_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_lt?: InputMaybe<Scalars['String']['input']>;
  symbol_lte?: InputMaybe<Scalars['String']['input']>;
  symbol_not?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenId?: InputMaybe<Scalars['Int']['input']>;
  tokenId_gt?: InputMaybe<Scalars['Int']['input']>;
  tokenId_gte?: InputMaybe<Scalars['Int']['input']>;
  tokenId_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  tokenId_lt?: InputMaybe<Scalars['Int']['input']>;
  tokenId_lte?: InputMaybe<Scalars['Int']['input']>;
  tokenId_not?: InputMaybe<Scalars['Int']['input']>;
  tokenId_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum DotcAssetOrderBy {
  Address = 'address',
  AssetType = 'assetType',
  Decimals = 'decimals',
  Id = 'id',
  Name = 'name',
  Symbol = 'symbol',
  TokenId = 'tokenId'
}

export type Erc20Token = {
  __typename?: 'ERC20Token';
  decimals: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  paused: Scalars['Boolean']['output'];
  symbol: Scalars['String']['output'];
  tvl: Scalars['BigDecimal']['output'];
};

export type Erc20TokenFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Erc20TokenFilter>>>;
  decimals?: InputMaybe<Scalars['Int']['input']>;
  decimals_gt?: InputMaybe<Scalars['Int']['input']>;
  decimals_gte?: InputMaybe<Scalars['Int']['input']>;
  decimals_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  decimals_lt?: InputMaybe<Scalars['Int']['input']>;
  decimals_lte?: InputMaybe<Scalars['Int']['input']>;
  decimals_not?: InputMaybe<Scalars['Int']['input']>;
  decimals_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<Erc20TokenFilter>>>;
  paused?: InputMaybe<Scalars['Boolean']['input']>;
  paused_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  paused_not?: InputMaybe<Scalars['Boolean']['input']>;
  paused_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  symbol_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_gt?: InputMaybe<Scalars['String']['input']>;
  symbol_gte?: InputMaybe<Scalars['String']['input']>;
  symbol_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_lt?: InputMaybe<Scalars['String']['input']>;
  symbol_lte?: InputMaybe<Scalars['String']['input']>;
  symbol_not?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tvl?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  tvl_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
};

export enum Erc20TokenOrderBy {
  Decimals = 'decimals',
  Id = 'id',
  Name = 'name',
  Paused = 'paused',
  Symbol = 'symbol',
  Tvl = 'tvl'
}

export type Erc1155Token = {
  __typename?: 'ERC1155Token';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  paused: Scalars['Boolean']['output'];
  symbol: Scalars['String']['output'];
  tvl: Scalars['BigDecimal']['output'];
};

export type Erc1155TokenFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Erc1155TokenFilter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<Erc1155TokenFilter>>>;
  paused?: InputMaybe<Scalars['Boolean']['input']>;
  paused_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  paused_not?: InputMaybe<Scalars['Boolean']['input']>;
  paused_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  symbol_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_gt?: InputMaybe<Scalars['String']['input']>;
  symbol_gte?: InputMaybe<Scalars['String']['input']>;
  symbol_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_lt?: InputMaybe<Scalars['String']['input']>;
  symbol_lte?: InputMaybe<Scalars['String']['input']>;
  symbol_not?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tvl?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  tvl_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
};

export enum Erc1155TokenOrderBy {
  Id = 'id',
  Name = 'name',
  Paused = 'paused',
  Symbol = 'symbol',
  Tvl = 'tvl'
}

export type KyaData = {
  __typename?: 'KyaData';
  /** Asset token */
  assetToken?: Maybe<AssetToken>;
  assetType: Scalars['String']['output'];
  blockchain?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalUrl?: Maybe<Scalars['String']['output']>;
  /** IPFS hash or path to the json file on ipfs */
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  redemptionAsset?: Maybe<Scalars['String']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
  underlyingAsset?: Maybe<Scalars['String']['output']>;
  underlyingAssetBlockchain?: Maybe<Scalars['String']['output']>;
};

export type KyaDataFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<KyaDataFilter>>>;
  assetToken_?: InputMaybe<AssetTokenFilter>;
  assetType?: InputMaybe<Scalars['String']['input']>;
  assetType_contains?: InputMaybe<Scalars['String']['input']>;
  assetType_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  assetType_ends_with?: InputMaybe<Scalars['String']['input']>;
  assetType_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  assetType_gt?: InputMaybe<Scalars['String']['input']>;
  assetType_gte?: InputMaybe<Scalars['String']['input']>;
  assetType_in?: InputMaybe<Array<Scalars['String']['input']>>;
  assetType_lt?: InputMaybe<Scalars['String']['input']>;
  assetType_lte?: InputMaybe<Scalars['String']['input']>;
  assetType_not?: InputMaybe<Scalars['String']['input']>;
  assetType_not_contains?: InputMaybe<Scalars['String']['input']>;
  assetType_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  assetType_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  assetType_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  assetType_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  assetType_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  assetType_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  assetType_starts_with?: InputMaybe<Scalars['String']['input']>;
  assetType_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  blockchain?: InputMaybe<Scalars['String']['input']>;
  blockchain_contains?: InputMaybe<Scalars['String']['input']>;
  blockchain_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  blockchain_ends_with?: InputMaybe<Scalars['String']['input']>;
  blockchain_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  blockchain_gt?: InputMaybe<Scalars['String']['input']>;
  blockchain_gte?: InputMaybe<Scalars['String']['input']>;
  blockchain_in?: InputMaybe<Array<Scalars['String']['input']>>;
  blockchain_lt?: InputMaybe<Scalars['String']['input']>;
  blockchain_lte?: InputMaybe<Scalars['String']['input']>;
  blockchain_not?: InputMaybe<Scalars['String']['input']>;
  blockchain_not_contains?: InputMaybe<Scalars['String']['input']>;
  blockchain_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  blockchain_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  blockchain_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  blockchain_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  blockchain_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  blockchain_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  blockchain_starts_with?: InputMaybe<Scalars['String']['input']>;
  blockchain_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  description_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<Scalars['String']['input']>>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  description_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  description_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  description_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  externalUrl_contains?: InputMaybe<Scalars['String']['input']>;
  externalUrl_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  externalUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  externalUrl_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  externalUrl_gt?: InputMaybe<Scalars['String']['input']>;
  externalUrl_gte?: InputMaybe<Scalars['String']['input']>;
  externalUrl_in?: InputMaybe<Array<Scalars['String']['input']>>;
  externalUrl_lt?: InputMaybe<Scalars['String']['input']>;
  externalUrl_lte?: InputMaybe<Scalars['String']['input']>;
  externalUrl_not?: InputMaybe<Scalars['String']['input']>;
  externalUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  externalUrl_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  externalUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  externalUrl_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  externalUrl_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  externalUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  externalUrl_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  externalUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  externalUrl_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  image?: InputMaybe<Scalars['String']['input']>;
  image_contains?: InputMaybe<Scalars['String']['input']>;
  image_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  image_ends_with?: InputMaybe<Scalars['String']['input']>;
  image_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  image_gt?: InputMaybe<Scalars['String']['input']>;
  image_gte?: InputMaybe<Scalars['String']['input']>;
  image_in?: InputMaybe<Array<Scalars['String']['input']>>;
  image_lt?: InputMaybe<Scalars['String']['input']>;
  image_lte?: InputMaybe<Scalars['String']['input']>;
  image_not?: InputMaybe<Scalars['String']['input']>;
  image_not_contains?: InputMaybe<Scalars['String']['input']>;
  image_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  image_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  image_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  image_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  image_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  image_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  image_starts_with?: InputMaybe<Scalars['String']['input']>;
  image_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<KyaDataFilter>>>;
  redemptionAsset?: InputMaybe<Scalars['String']['input']>;
  redemptionAsset_contains?: InputMaybe<Scalars['String']['input']>;
  redemptionAsset_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  redemptionAsset_ends_with?: InputMaybe<Scalars['String']['input']>;
  redemptionAsset_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  redemptionAsset_gt?: InputMaybe<Scalars['String']['input']>;
  redemptionAsset_gte?: InputMaybe<Scalars['String']['input']>;
  redemptionAsset_in?: InputMaybe<Array<Scalars['String']['input']>>;
  redemptionAsset_lt?: InputMaybe<Scalars['String']['input']>;
  redemptionAsset_lte?: InputMaybe<Scalars['String']['input']>;
  redemptionAsset_not?: InputMaybe<Scalars['String']['input']>;
  redemptionAsset_not_contains?: InputMaybe<Scalars['String']['input']>;
  redemptionAsset_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  redemptionAsset_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  redemptionAsset_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  redemptionAsset_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  redemptionAsset_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  redemptionAsset_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  redemptionAsset_starts_with?: InputMaybe<Scalars['String']['input']>;
  redemptionAsset_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  symbol_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_gt?: InputMaybe<Scalars['String']['input']>;
  symbol_gte?: InputMaybe<Scalars['String']['input']>;
  symbol_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_lt?: InputMaybe<Scalars['String']['input']>;
  symbol_lte?: InputMaybe<Scalars['String']['input']>;
  symbol_not?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  underlyingAsset?: InputMaybe<Scalars['String']['input']>;
  underlyingAssetBlockchain?: InputMaybe<Scalars['String']['input']>;
  underlyingAssetBlockchain_contains?: InputMaybe<Scalars['String']['input']>;
  underlyingAssetBlockchain_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  underlyingAssetBlockchain_ends_with?: InputMaybe<Scalars['String']['input']>;
  underlyingAssetBlockchain_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  underlyingAssetBlockchain_gt?: InputMaybe<Scalars['String']['input']>;
  underlyingAssetBlockchain_gte?: InputMaybe<Scalars['String']['input']>;
  underlyingAssetBlockchain_in?: InputMaybe<Array<Scalars['String']['input']>>;
  underlyingAssetBlockchain_lt?: InputMaybe<Scalars['String']['input']>;
  underlyingAssetBlockchain_lte?: InputMaybe<Scalars['String']['input']>;
  underlyingAssetBlockchain_not?: InputMaybe<Scalars['String']['input']>;
  underlyingAssetBlockchain_not_contains?: InputMaybe<Scalars['String']['input']>;
  underlyingAssetBlockchain_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  underlyingAssetBlockchain_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  underlyingAssetBlockchain_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  underlyingAssetBlockchain_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  underlyingAssetBlockchain_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  underlyingAssetBlockchain_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  underlyingAssetBlockchain_starts_with?: InputMaybe<Scalars['String']['input']>;
  underlyingAssetBlockchain_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  underlyingAsset_contains?: InputMaybe<Scalars['String']['input']>;
  underlyingAsset_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  underlyingAsset_ends_with?: InputMaybe<Scalars['String']['input']>;
  underlyingAsset_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  underlyingAsset_gt?: InputMaybe<Scalars['String']['input']>;
  underlyingAsset_gte?: InputMaybe<Scalars['String']['input']>;
  underlyingAsset_in?: InputMaybe<Array<Scalars['String']['input']>>;
  underlyingAsset_lt?: InputMaybe<Scalars['String']['input']>;
  underlyingAsset_lte?: InputMaybe<Scalars['String']['input']>;
  underlyingAsset_not?: InputMaybe<Scalars['String']['input']>;
  underlyingAsset_not_contains?: InputMaybe<Scalars['String']['input']>;
  underlyingAsset_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  underlyingAsset_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  underlyingAsset_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  underlyingAsset_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  underlyingAsset_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  underlyingAsset_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  underlyingAsset_starts_with?: InputMaybe<Scalars['String']['input']>;
  underlyingAsset_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum KyaDataOrderBy {
  AssetToken = 'assetToken',
  AssetTokenOne = 'assetToken__ONE',
  AssetTokenDecimals = 'assetToken__decimals',
  AssetTokenEnabled = 'assetToken__enabled',
  AssetTokenFrozen = 'assetToken__frozen',
  AssetTokenGuardian = 'assetToken__guardian',
  AssetTokenId = 'assetToken__id',
  AssetTokenIsOnSafeGuard = 'assetToken__isOnSafeGuard',
  AssetTokenKya = 'assetToken__kya',
  AssetTokenLastInterestRate = 'assetToken__lastInterestRate',
  AssetTokenLastUpdate = 'assetToken__lastUpdate',
  AssetTokenMinimumRedemptionAmount = 'assetToken__minimumRedemptionAmount',
  AssetTokenName = 'assetToken__name',
  AssetTokenPositiveInterest = 'assetToken__positiveInterest',
  AssetTokenRate = 'assetToken__rate',
  AssetTokenStatePercent = 'assetToken__statePercent',
  AssetTokenSymbol = 'assetToken__symbol',
  AssetTokenType = 'assetToken__type',
  AssetType = 'assetType',
  Blockchain = 'blockchain',
  Description = 'description',
  ExternalUrl = 'externalUrl',
  Id = 'id',
  Image = 'image',
  Name = 'name',
  RedemptionAsset = 'redemptionAsset',
  Symbol = 'symbol',
  UnderlyingAsset = 'underlyingAsset',
  UnderlyingAssetBlockchain = 'underlyingAssetBlockchain'
}

export type NewCrPoolToken = {
  __typename?: 'NewCRPoolToken';
  balance: Scalars['BigInt']['output'];
  commitBlock: Scalars['BigInt']['output'];
  denormWeight: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  pool: Pool;
  token: Token;
};

export type NewCrPoolTokenFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<NewCrPoolTokenFilter>>>;
  balance?: InputMaybe<Scalars['BigInt']['input']>;
  balance_gt?: InputMaybe<Scalars['BigInt']['input']>;
  balance_gte?: InputMaybe<Scalars['BigInt']['input']>;
  balance_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  balance_lt?: InputMaybe<Scalars['BigInt']['input']>;
  balance_lte?: InputMaybe<Scalars['BigInt']['input']>;
  balance_not?: InputMaybe<Scalars['BigInt']['input']>;
  balance_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  commitBlock?: InputMaybe<Scalars['BigInt']['input']>;
  commitBlock_gt?: InputMaybe<Scalars['BigInt']['input']>;
  commitBlock_gte?: InputMaybe<Scalars['BigInt']['input']>;
  commitBlock_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  commitBlock_lt?: InputMaybe<Scalars['BigInt']['input']>;
  commitBlock_lte?: InputMaybe<Scalars['BigInt']['input']>;
  commitBlock_not?: InputMaybe<Scalars['BigInt']['input']>;
  commitBlock_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  denormWeight?: InputMaybe<Scalars['BigInt']['input']>;
  denormWeight_gt?: InputMaybe<Scalars['BigInt']['input']>;
  denormWeight_gte?: InputMaybe<Scalars['BigInt']['input']>;
  denormWeight_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  denormWeight_lt?: InputMaybe<Scalars['BigInt']['input']>;
  denormWeight_lte?: InputMaybe<Scalars['BigInt']['input']>;
  denormWeight_not?: InputMaybe<Scalars['BigInt']['input']>;
  denormWeight_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<NewCrPoolTokenFilter>>>;
  pool?: InputMaybe<Scalars['String']['input']>;
  pool_?: InputMaybe<PoolFilter>;
  pool_contains?: InputMaybe<Scalars['String']['input']>;
  pool_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_gt?: InputMaybe<Scalars['String']['input']>;
  pool_gte?: InputMaybe<Scalars['String']['input']>;
  pool_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_lt?: InputMaybe<Scalars['String']['input']>;
  pool_lte?: InputMaybe<Scalars['String']['input']>;
  pool_not?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains?: InputMaybe<Scalars['String']['input']>;
  pool_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pool_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with?: InputMaybe<Scalars['String']['input']>;
  pool_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  token_?: InputMaybe<TokenFilter>;
  token_contains?: InputMaybe<Scalars['String']['input']>;
  token_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token_ends_with?: InputMaybe<Scalars['String']['input']>;
  token_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token_gt?: InputMaybe<Scalars['String']['input']>;
  token_gte?: InputMaybe<Scalars['String']['input']>;
  token_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token_lt?: InputMaybe<Scalars['String']['input']>;
  token_lte?: InputMaybe<Scalars['String']['input']>;
  token_not?: InputMaybe<Scalars['String']['input']>;
  token_not_contains?: InputMaybe<Scalars['String']['input']>;
  token_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  token_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  token_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token_starts_with?: InputMaybe<Scalars['String']['input']>;
  token_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum NewCrPoolTokenOrderBy {
  Balance = 'balance',
  CommitBlock = 'commitBlock',
  DenormWeight = 'denormWeight',
  Id = 'id',
  Pool = 'pool',
  PoolActive = 'pool__active',
  PoolAddTokenTimeLockInBlocks = 'pool__addTokenTimeLockInBlocks',
  PoolCap = 'pool__cap',
  PoolController = 'pool__controller',
  PoolCreateTime = 'pool__createTime',
  PoolCrp = 'pool__crp',
  PoolCrpController = 'pool__crpController',
  PoolExitsCount = 'pool__exitsCount',
  PoolFinalized = 'pool__finalized',
  PoolHoldersCount = 'pool__holdersCount',
  PoolId = 'pool__id',
  PoolJoinsCount = 'pool__joinsCount',
  PoolLiquidity = 'pool__liquidity',
  PoolLogAddress = 'pool__logAddress',
  PoolMinimumWeightChangeBlockPeriod = 'pool__minimumWeightChangeBlockPeriod',
  PoolName = 'pool__name',
  PoolPublicSwap = 'pool__publicSwap',
  PoolSwapFee = 'pool__swapFee',
  PoolSwapsCount = 'pool__swapsCount',
  PoolSymbol = 'pool__symbol',
  PoolTokensCount = 'pool__tokensCount',
  PoolTotalShares = 'pool__totalShares',
  PoolTotalSwapFee = 'pool__totalSwapFee',
  PoolTotalSwapVolume = 'pool__totalSwapVolume',
  PoolTotalWeight = 'pool__totalWeight',
  PoolTx = 'pool__tx',
  Token = 'token',
  TokenDecimals = 'token__decimals',
  TokenId = 'token__id',
  TokenIsLpt = 'token__isLPT',
  TokenName = 'token__name',
  TokenPaused = 'token__paused',
  TokenSymbol = 'token__symbol',
  TokenTvl = 'token__tvl'
}

export type Offer = {
  __typename?: 'Offer';
  amountIn: Scalars['BigDecimal']['output'];
  amountOut: Scalars['BigDecimal']['output'];
  availableAmount: Scalars['BigDecimal']['output'];
  cancelled: Scalars['Boolean']['output'];
  createdAt: Scalars['BigInt']['output'];
  expiresAt: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  isCompleted: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  maker: Scalars['Bytes']['output'];
  offerType: Scalars['BigInt']['output'];
  orders: Array<Order>;
  price: Scalars['BigDecimal']['output'];
  specialAddress?: Maybe<Scalars['Bytes']['output']>;
  timelockPeriod: Scalars['BigInt']['output'];
  tokenIn: Erc20Token;
  tokenOut: Erc20Token;
};


export type OfferOrdersArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderFilter>;
};

export type OfferFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  amountIn?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountIn_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountIn_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountIn_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  amountIn_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountIn_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountIn_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountIn_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  amountOut?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountOut_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountOut_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountOut_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  amountOut_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountOut_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountOut_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountOut_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  and?: InputMaybe<Array<InputMaybe<OfferFilter>>>;
  availableAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
  availableAmount_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  availableAmount_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  availableAmount_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  availableAmount_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  availableAmount_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  availableAmount_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  availableAmount_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  cancelled_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  cancelled_not?: InputMaybe<Scalars['Boolean']['input']>;
  cancelled_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  createdAt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  expiresAt?: InputMaybe<Scalars['BigInt']['input']>;
  expiresAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  expiresAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  expiresAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  expiresAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  expiresAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  expiresAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  expiresAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isCompleted_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isCompleted_not?: InputMaybe<Scalars['Boolean']['input']>;
  isCompleted_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isPrivate_not?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  maker?: InputMaybe<Scalars['Bytes']['input']>;
  maker_contains?: InputMaybe<Scalars['Bytes']['input']>;
  maker_gt?: InputMaybe<Scalars['Bytes']['input']>;
  maker_gte?: InputMaybe<Scalars['Bytes']['input']>;
  maker_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  maker_lt?: InputMaybe<Scalars['Bytes']['input']>;
  maker_lte?: InputMaybe<Scalars['Bytes']['input']>;
  maker_not?: InputMaybe<Scalars['Bytes']['input']>;
  maker_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  maker_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  offerType?: InputMaybe<Scalars['BigInt']['input']>;
  offerType_gt?: InputMaybe<Scalars['BigInt']['input']>;
  offerType_gte?: InputMaybe<Scalars['BigInt']['input']>;
  offerType_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  offerType_lt?: InputMaybe<Scalars['BigInt']['input']>;
  offerType_lte?: InputMaybe<Scalars['BigInt']['input']>;
  offerType_not?: InputMaybe<Scalars['BigInt']['input']>;
  offerType_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  or?: InputMaybe<Array<InputMaybe<OfferFilter>>>;
  orders_?: InputMaybe<OrderFilter>;
  price?: InputMaybe<Scalars['BigDecimal']['input']>;
  price_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  price_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  price_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  price_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  price_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  price_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  price_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  specialAddress?: InputMaybe<Scalars['Bytes']['input']>;
  specialAddress_contains?: InputMaybe<Scalars['Bytes']['input']>;
  specialAddress_gt?: InputMaybe<Scalars['Bytes']['input']>;
  specialAddress_gte?: InputMaybe<Scalars['Bytes']['input']>;
  specialAddress_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  specialAddress_lt?: InputMaybe<Scalars['Bytes']['input']>;
  specialAddress_lte?: InputMaybe<Scalars['Bytes']['input']>;
  specialAddress_not?: InputMaybe<Scalars['Bytes']['input']>;
  specialAddress_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  specialAddress_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  timelockPeriod?: InputMaybe<Scalars['BigInt']['input']>;
  timelockPeriod_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timelockPeriod_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timelockPeriod_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timelockPeriod_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timelockPeriod_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timelockPeriod_not?: InputMaybe<Scalars['BigInt']['input']>;
  timelockPeriod_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tokenIn?: InputMaybe<Scalars['String']['input']>;
  tokenIn_?: InputMaybe<Erc20TokenFilter>;
  tokenIn_contains?: InputMaybe<Scalars['String']['input']>;
  tokenIn_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenIn_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenIn_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenIn_gt?: InputMaybe<Scalars['String']['input']>;
  tokenIn_gte?: InputMaybe<Scalars['String']['input']>;
  tokenIn_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenIn_lt?: InputMaybe<Scalars['String']['input']>;
  tokenIn_lte?: InputMaybe<Scalars['String']['input']>;
  tokenIn_not?: InputMaybe<Scalars['String']['input']>;
  tokenIn_not_contains?: InputMaybe<Scalars['String']['input']>;
  tokenIn_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenIn_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenIn_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenIn_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenIn_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenIn_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenIn_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenIn_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenOut?: InputMaybe<Scalars['String']['input']>;
  tokenOut_?: InputMaybe<Erc20TokenFilter>;
  tokenOut_contains?: InputMaybe<Scalars['String']['input']>;
  tokenOut_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenOut_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenOut_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenOut_gt?: InputMaybe<Scalars['String']['input']>;
  tokenOut_gte?: InputMaybe<Scalars['String']['input']>;
  tokenOut_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenOut_lt?: InputMaybe<Scalars['String']['input']>;
  tokenOut_lte?: InputMaybe<Scalars['String']['input']>;
  tokenOut_not?: InputMaybe<Scalars['String']['input']>;
  tokenOut_not_contains?: InputMaybe<Scalars['String']['input']>;
  tokenOut_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenOut_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenOut_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenOut_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenOut_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenOut_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenOut_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenOut_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum OfferOrderBy {
  AmountIn = 'amountIn',
  AmountOut = 'amountOut',
  AvailableAmount = 'availableAmount',
  Cancelled = 'cancelled',
  CreatedAt = 'createdAt',
  ExpiresAt = 'expiresAt',
  Id = 'id',
  IsCompleted = 'isCompleted',
  IsPrivate = 'isPrivate',
  Maker = 'maker',
  OfferType = 'offerType',
  Orders = 'orders',
  Price = 'price',
  SpecialAddress = 'specialAddress',
  TimelockPeriod = 'timelockPeriod',
  TokenIn = 'tokenIn',
  TokenInDecimals = 'tokenIn__decimals',
  TokenInId = 'tokenIn__id',
  TokenInName = 'tokenIn__name',
  TokenInPaused = 'tokenIn__paused',
  TokenInSymbol = 'tokenIn__symbol',
  TokenInTvl = 'tokenIn__tvl',
  TokenOut = 'tokenOut',
  TokenOutDecimals = 'tokenOut__decimals',
  TokenOutId = 'tokenOut__id',
  TokenOutName = 'tokenOut__name',
  TokenOutPaused = 'tokenOut__paused',
  TokenOutSymbol = 'tokenOut__symbol',
  TokenOutTvl = 'tokenOut__tvl'
}

export type OpenOffer = {
  __typename?: 'OpenOffer';
  amountIn: Scalars['BigDecimal']['output'];
  amountOut: Scalars['BigDecimal']['output'];
  availableAmount: Scalars['BigDecimal']['output'];
  cancelled: Scalars['Boolean']['output'];
  createdAt: Scalars['BigInt']['output'];
  depositAsset: DotcAsset;
  expiresAt: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  isCompleted: Scalars['Boolean']['output'];
  isFullType: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  maker: Scalars['Bytes']['output'];
  price: Scalars['BigDecimal']['output'];
  specialAddress?: Maybe<Scalars['Bytes']['output']>;
  timelockPeriod: Scalars['BigInt']['output'];
  withdrawalAsset: DotcAsset;
};

export type OpenOfferFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  amountIn?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountIn_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountIn_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountIn_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  amountIn_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountIn_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountIn_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountIn_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  amountOut?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountOut_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountOut_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountOut_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  amountOut_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountOut_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountOut_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountOut_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  and?: InputMaybe<Array<InputMaybe<OpenOfferFilter>>>;
  availableAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
  availableAmount_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  availableAmount_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  availableAmount_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  availableAmount_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  availableAmount_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  availableAmount_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  availableAmount_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  cancelled_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  cancelled_not?: InputMaybe<Scalars['Boolean']['input']>;
  cancelled_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  createdAt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  depositAsset?: InputMaybe<Scalars['String']['input']>;
  depositAsset_?: InputMaybe<DotcAssetFilter>;
  depositAsset_contains?: InputMaybe<Scalars['String']['input']>;
  depositAsset_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  depositAsset_ends_with?: InputMaybe<Scalars['String']['input']>;
  depositAsset_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  depositAsset_gt?: InputMaybe<Scalars['String']['input']>;
  depositAsset_gte?: InputMaybe<Scalars['String']['input']>;
  depositAsset_in?: InputMaybe<Array<Scalars['String']['input']>>;
  depositAsset_lt?: InputMaybe<Scalars['String']['input']>;
  depositAsset_lte?: InputMaybe<Scalars['String']['input']>;
  depositAsset_not?: InputMaybe<Scalars['String']['input']>;
  depositAsset_not_contains?: InputMaybe<Scalars['String']['input']>;
  depositAsset_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  depositAsset_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  depositAsset_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  depositAsset_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  depositAsset_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  depositAsset_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  depositAsset_starts_with?: InputMaybe<Scalars['String']['input']>;
  depositAsset_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['BigInt']['input']>;
  expiresAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  expiresAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  expiresAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  expiresAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  expiresAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  expiresAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  expiresAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isCompleted_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isCompleted_not?: InputMaybe<Scalars['Boolean']['input']>;
  isCompleted_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isFullType?: InputMaybe<Scalars['Boolean']['input']>;
  isFullType_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isFullType_not?: InputMaybe<Scalars['Boolean']['input']>;
  isFullType_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isPrivate_not?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  maker?: InputMaybe<Scalars['Bytes']['input']>;
  maker_contains?: InputMaybe<Scalars['Bytes']['input']>;
  maker_gt?: InputMaybe<Scalars['Bytes']['input']>;
  maker_gte?: InputMaybe<Scalars['Bytes']['input']>;
  maker_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  maker_lt?: InputMaybe<Scalars['Bytes']['input']>;
  maker_lte?: InputMaybe<Scalars['Bytes']['input']>;
  maker_not?: InputMaybe<Scalars['Bytes']['input']>;
  maker_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  maker_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  or?: InputMaybe<Array<InputMaybe<OpenOfferFilter>>>;
  price?: InputMaybe<Scalars['BigDecimal']['input']>;
  price_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  price_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  price_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  price_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  price_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  price_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  price_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  specialAddress?: InputMaybe<Scalars['Bytes']['input']>;
  specialAddress_contains?: InputMaybe<Scalars['Bytes']['input']>;
  specialAddress_gt?: InputMaybe<Scalars['Bytes']['input']>;
  specialAddress_gte?: InputMaybe<Scalars['Bytes']['input']>;
  specialAddress_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  specialAddress_lt?: InputMaybe<Scalars['Bytes']['input']>;
  specialAddress_lte?: InputMaybe<Scalars['Bytes']['input']>;
  specialAddress_not?: InputMaybe<Scalars['Bytes']['input']>;
  specialAddress_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  specialAddress_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  timelockPeriod?: InputMaybe<Scalars['BigInt']['input']>;
  timelockPeriod_gt?: InputMaybe<Scalars['BigInt']['input']>;
  timelockPeriod_gte?: InputMaybe<Scalars['BigInt']['input']>;
  timelockPeriod_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  timelockPeriod_lt?: InputMaybe<Scalars['BigInt']['input']>;
  timelockPeriod_lte?: InputMaybe<Scalars['BigInt']['input']>;
  timelockPeriod_not?: InputMaybe<Scalars['BigInt']['input']>;
  timelockPeriod_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  withdrawalAsset?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_?: InputMaybe<DotcAssetFilter>;
  withdrawalAsset_contains?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_ends_with?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_gt?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_gte?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_in?: InputMaybe<Array<Scalars['String']['input']>>;
  withdrawalAsset_lt?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_lte?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_not?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_not_contains?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  withdrawalAsset_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_starts_with?: InputMaybe<Scalars['String']['input']>;
  withdrawalAsset_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum OpenOfferOrderBy {
  AmountIn = 'amountIn',
  AmountOut = 'amountOut',
  AvailableAmount = 'availableAmount',
  Cancelled = 'cancelled',
  CreatedAt = 'createdAt',
  DepositAsset = 'depositAsset',
  DepositAssetAddress = 'depositAsset__address',
  DepositAssetAssetType = 'depositAsset__assetType',
  DepositAssetDecimals = 'depositAsset__decimals',
  DepositAssetId = 'depositAsset__id',
  DepositAssetName = 'depositAsset__name',
  DepositAssetSymbol = 'depositAsset__symbol',
  DepositAssetTokenId = 'depositAsset__tokenId',
  ExpiresAt = 'expiresAt',
  Id = 'id',
  IsCompleted = 'isCompleted',
  IsFullType = 'isFullType',
  IsPrivate = 'isPrivate',
  Maker = 'maker',
  Price = 'price',
  SpecialAddress = 'specialAddress',
  TimelockPeriod = 'timelockPeriod',
  WithdrawalAsset = 'withdrawalAsset',
  WithdrawalAssetAddress = 'withdrawalAsset__address',
  WithdrawalAssetAssetType = 'withdrawalAsset__assetType',
  WithdrawalAssetDecimals = 'withdrawalAsset__decimals',
  WithdrawalAssetId = 'withdrawalAsset__id',
  WithdrawalAssetName = 'withdrawalAsset__name',
  WithdrawalAssetSymbol = 'withdrawalAsset__symbol',
  WithdrawalAssetTokenId = 'withdrawalAsset__tokenId'
}

export type OpenOrder = {
  __typename?: 'OpenOrder';
  amountPaid: Scalars['BigDecimal']['output'];
  amountToReceive: Scalars['BigDecimal']['output'];
  createdAt: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  openOffer: OpenOffer;
  orderedBy: Scalars['Bytes']['output'];
};

export type OpenOrderFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  amountPaid?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountPaid_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountPaid_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountPaid_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  amountPaid_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountPaid_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountPaid_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountPaid_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  amountToReceive?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountToReceive_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountToReceive_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountToReceive_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  amountToReceive_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountToReceive_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountToReceive_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountToReceive_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  and?: InputMaybe<Array<InputMaybe<OpenOrderFilter>>>;
  createdAt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  openOffer?: InputMaybe<Scalars['String']['input']>;
  openOffer_?: InputMaybe<OpenOfferFilter>;
  openOffer_contains?: InputMaybe<Scalars['String']['input']>;
  openOffer_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  openOffer_ends_with?: InputMaybe<Scalars['String']['input']>;
  openOffer_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  openOffer_gt?: InputMaybe<Scalars['String']['input']>;
  openOffer_gte?: InputMaybe<Scalars['String']['input']>;
  openOffer_in?: InputMaybe<Array<Scalars['String']['input']>>;
  openOffer_lt?: InputMaybe<Scalars['String']['input']>;
  openOffer_lte?: InputMaybe<Scalars['String']['input']>;
  openOffer_not?: InputMaybe<Scalars['String']['input']>;
  openOffer_not_contains?: InputMaybe<Scalars['String']['input']>;
  openOffer_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  openOffer_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  openOffer_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  openOffer_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  openOffer_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  openOffer_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  openOffer_starts_with?: InputMaybe<Scalars['String']['input']>;
  openOffer_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<OpenOrderFilter>>>;
  orderedBy?: InputMaybe<Scalars['Bytes']['input']>;
  orderedBy_contains?: InputMaybe<Scalars['Bytes']['input']>;
  orderedBy_gt?: InputMaybe<Scalars['Bytes']['input']>;
  orderedBy_gte?: InputMaybe<Scalars['Bytes']['input']>;
  orderedBy_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  orderedBy_lt?: InputMaybe<Scalars['Bytes']['input']>;
  orderedBy_lte?: InputMaybe<Scalars['Bytes']['input']>;
  orderedBy_not?: InputMaybe<Scalars['Bytes']['input']>;
  orderedBy_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  orderedBy_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
};

export enum OpenOrderOrderBy {
  AmountPaid = 'amountPaid',
  AmountToReceive = 'amountToReceive',
  CreatedAt = 'createdAt',
  Id = 'id',
  OpenOffer = 'openOffer',
  OpenOfferAmountIn = 'openOffer__amountIn',
  OpenOfferAmountOut = 'openOffer__amountOut',
  OpenOfferAvailableAmount = 'openOffer__availableAmount',
  OpenOfferCancelled = 'openOffer__cancelled',
  OpenOfferCreatedAt = 'openOffer__createdAt',
  OpenOfferExpiresAt = 'openOffer__expiresAt',
  OpenOfferId = 'openOffer__id',
  OpenOfferIsCompleted = 'openOffer__isCompleted',
  OpenOfferIsFullType = 'openOffer__isFullType',
  OpenOfferIsPrivate = 'openOffer__isPrivate',
  OpenOfferMaker = 'openOffer__maker',
  OpenOfferPrice = 'openOffer__price',
  OpenOfferSpecialAddress = 'openOffer__specialAddress',
  OpenOfferTimelockPeriod = 'openOffer__timelockPeriod',
  OrderedBy = 'orderedBy'
}

export type Order = {
  __typename?: 'Order';
  amountPaid: Scalars['BigDecimal']['output'];
  amountToReceive: Scalars['BigDecimal']['output'];
  createdAt: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  offers: Offer;
  orderedBy: Scalars['Bytes']['output'];
};

/** Defines the order direction, either ascending or descending */
export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type OrderFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  amountPaid?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountPaid_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountPaid_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountPaid_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  amountPaid_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountPaid_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountPaid_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountPaid_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  amountToReceive?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountToReceive_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountToReceive_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountToReceive_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  amountToReceive_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountToReceive_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountToReceive_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  amountToReceive_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  and?: InputMaybe<Array<InputMaybe<OrderFilter>>>;
  createdAt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_gt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_gte?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_lte?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_not?: InputMaybe<Scalars['BigInt']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  offers?: InputMaybe<Scalars['String']['input']>;
  offers_?: InputMaybe<OfferFilter>;
  offers_contains?: InputMaybe<Scalars['String']['input']>;
  offers_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  offers_ends_with?: InputMaybe<Scalars['String']['input']>;
  offers_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  offers_gt?: InputMaybe<Scalars['String']['input']>;
  offers_gte?: InputMaybe<Scalars['String']['input']>;
  offers_in?: InputMaybe<Array<Scalars['String']['input']>>;
  offers_lt?: InputMaybe<Scalars['String']['input']>;
  offers_lte?: InputMaybe<Scalars['String']['input']>;
  offers_not?: InputMaybe<Scalars['String']['input']>;
  offers_not_contains?: InputMaybe<Scalars['String']['input']>;
  offers_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  offers_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  offers_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  offers_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  offers_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  offers_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  offers_starts_with?: InputMaybe<Scalars['String']['input']>;
  offers_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<OrderFilter>>>;
  orderedBy?: InputMaybe<Scalars['Bytes']['input']>;
  orderedBy_contains?: InputMaybe<Scalars['Bytes']['input']>;
  orderedBy_gt?: InputMaybe<Scalars['Bytes']['input']>;
  orderedBy_gte?: InputMaybe<Scalars['Bytes']['input']>;
  orderedBy_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  orderedBy_lt?: InputMaybe<Scalars['Bytes']['input']>;
  orderedBy_lte?: InputMaybe<Scalars['Bytes']['input']>;
  orderedBy_not?: InputMaybe<Scalars['Bytes']['input']>;
  orderedBy_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  orderedBy_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
};

export enum OrderOrderBy {
  AmountPaid = 'amountPaid',
  AmountToReceive = 'amountToReceive',
  CreatedAt = 'createdAt',
  Id = 'id',
  Offers = 'offers',
  OffersAmountIn = 'offers__amountIn',
  OffersAmountOut = 'offers__amountOut',
  OffersAvailableAmount = 'offers__availableAmount',
  OffersCancelled = 'offers__cancelled',
  OffersCreatedAt = 'offers__createdAt',
  OffersExpiresAt = 'offers__expiresAt',
  OffersId = 'offers__id',
  OffersIsCompleted = 'offers__isCompleted',
  OffersIsPrivate = 'offers__isPrivate',
  OffersMaker = 'offers__maker',
  OffersOfferType = 'offers__offerType',
  OffersPrice = 'offers__price',
  OffersSpecialAddress = 'offers__specialAddress',
  OffersTimelockPeriod = 'offers__timelockPeriod',
  OrderedBy = 'orderedBy'
}

export type Pool = {
  __typename?: 'Pool';
  active: Scalars['Boolean']['output'];
  addTokenTimeLockInBlocks: Scalars['BigInt']['output'];
  cap?: Maybe<Scalars['BigInt']['output']>;
  controller: Scalars['Bytes']['output'];
  createTime: Scalars['Int']['output'];
  crp: Scalars['Boolean']['output'];
  crpController?: Maybe<Scalars['Bytes']['output']>;
  crpoolGradualWeightsUpdate?: Maybe<CrPoolGradualWeightsUpdate>;
  exitsCount: Scalars['BigInt']['output'];
  factoryID: Balancer;
  finalized: Scalars['Boolean']['output'];
  holders: Array<Scalars['Bytes']['output']>;
  holdersCount: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  joinsCount: Scalars['BigInt']['output'];
  liquidity: Scalars['BigDecimal']['output'];
  liquidityPoolToken: Token;
  logAddress?: Maybe<Scalars['Bytes']['output']>;
  minimumWeightChangeBlockPeriod: Scalars['BigInt']['output'];
  name?: Maybe<Scalars['String']['output']>;
  newCRPoolToken?: Maybe<NewCrPoolToken>;
  publicSwap: Scalars['Boolean']['output'];
  rights: Array<Scalars['String']['output']>;
  shares?: Maybe<Array<PoolShare>>;
  swapFee: Scalars['BigDecimal']['output'];
  swaps?: Maybe<Array<Swap>>;
  swapsCount: Scalars['BigInt']['output'];
  symbol?: Maybe<Scalars['String']['output']>;
  tokens?: Maybe<Array<PoolToken>>;
  tokensCount: Scalars['BigInt']['output'];
  tokensList: Array<Scalars['Bytes']['output']>;
  totalShares: Scalars['BigDecimal']['output'];
  totalSwapFee: Scalars['BigDecimal']['output'];
  totalSwapVolume: Scalars['BigDecimal']['output'];
  totalWeight: Scalars['BigDecimal']['output'];
  tx?: Maybe<Scalars['Bytes']['output']>;
  whitelist: Array<Scalars['Bytes']['output']>;
};


export type PoolSharesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolShareOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PoolShareFilter>;
};


export type PoolSwapsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SwapOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SwapFilter>;
};


export type PoolTokensArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolTokenOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PoolTokenFilter>;
};

export type PoolShare = {
  __typename?: 'PoolShare';
  balance: Scalars['BigDecimal']['output'];
  id: Scalars['ID']['output'];
  poolId: Pool;
  userAddress: User;
};

export type PoolShareFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<PoolShareFilter>>>;
  balance?: InputMaybe<Scalars['BigDecimal']['input']>;
  balance_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  balance_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  balance_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  balance_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  balance_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  balance_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  balance_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<PoolShareFilter>>>;
  poolId?: InputMaybe<Scalars['String']['input']>;
  poolId_?: InputMaybe<PoolFilter>;
  poolId_contains?: InputMaybe<Scalars['String']['input']>;
  poolId_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  poolId_ends_with?: InputMaybe<Scalars['String']['input']>;
  poolId_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolId_gt?: InputMaybe<Scalars['String']['input']>;
  poolId_gte?: InputMaybe<Scalars['String']['input']>;
  poolId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  poolId_lt?: InputMaybe<Scalars['String']['input']>;
  poolId_lte?: InputMaybe<Scalars['String']['input']>;
  poolId_not?: InputMaybe<Scalars['String']['input']>;
  poolId_not_contains?: InputMaybe<Scalars['String']['input']>;
  poolId_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  poolId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  poolId_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolId_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  poolId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  poolId_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolId_starts_with?: InputMaybe<Scalars['String']['input']>;
  poolId_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  userAddress?: InputMaybe<Scalars['String']['input']>;
  userAddress_?: InputMaybe<UserFilter>;
  userAddress_contains?: InputMaybe<Scalars['String']['input']>;
  userAddress_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  userAddress_ends_with?: InputMaybe<Scalars['String']['input']>;
  userAddress_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  userAddress_gt?: InputMaybe<Scalars['String']['input']>;
  userAddress_gte?: InputMaybe<Scalars['String']['input']>;
  userAddress_in?: InputMaybe<Array<Scalars['String']['input']>>;
  userAddress_lt?: InputMaybe<Scalars['String']['input']>;
  userAddress_lte?: InputMaybe<Scalars['String']['input']>;
  userAddress_not?: InputMaybe<Scalars['String']['input']>;
  userAddress_not_contains?: InputMaybe<Scalars['String']['input']>;
  userAddress_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  userAddress_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  userAddress_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  userAddress_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  userAddress_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  userAddress_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  userAddress_starts_with?: InputMaybe<Scalars['String']['input']>;
  userAddress_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum PoolShareOrderBy {
  Balance = 'balance',
  Id = 'id',
  PoolId = 'poolId',
  PoolIdActive = 'poolId__active',
  PoolIdAddTokenTimeLockInBlocks = 'poolId__addTokenTimeLockInBlocks',
  PoolIdCap = 'poolId__cap',
  PoolIdController = 'poolId__controller',
  PoolIdCreateTime = 'poolId__createTime',
  PoolIdCrp = 'poolId__crp',
  PoolIdCrpController = 'poolId__crpController',
  PoolIdExitsCount = 'poolId__exitsCount',
  PoolIdFinalized = 'poolId__finalized',
  PoolIdHoldersCount = 'poolId__holdersCount',
  PoolIdId = 'poolId__id',
  PoolIdJoinsCount = 'poolId__joinsCount',
  PoolIdLiquidity = 'poolId__liquidity',
  PoolIdLogAddress = 'poolId__logAddress',
  PoolIdMinimumWeightChangeBlockPeriod = 'poolId__minimumWeightChangeBlockPeriod',
  PoolIdName = 'poolId__name',
  PoolIdPublicSwap = 'poolId__publicSwap',
  PoolIdSwapFee = 'poolId__swapFee',
  PoolIdSwapsCount = 'poolId__swapsCount',
  PoolIdSymbol = 'poolId__symbol',
  PoolIdTokensCount = 'poolId__tokensCount',
  PoolIdTotalShares = 'poolId__totalShares',
  PoolIdTotalSwapFee = 'poolId__totalSwapFee',
  PoolIdTotalSwapVolume = 'poolId__totalSwapVolume',
  PoolIdTotalWeight = 'poolId__totalWeight',
  PoolIdTx = 'poolId__tx',
  UserAddress = 'userAddress',
  UserAddressId = 'userAddress__id',
  UserAddressProxyAddress = 'userAddress__proxyAddress'
}

export type PoolToken = {
  __typename?: 'PoolToken';
  address: Scalars['String']['output'];
  balance: Scalars['BigDecimal']['output'];
  decimals: Scalars['Int']['output'];
  denormWeight: Scalars['BigDecimal']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  poolId: Pool;
  symbol?: Maybe<Scalars['String']['output']>;
  xToken: XToken;
};

export type PoolTokenFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  address?: InputMaybe<Scalars['String']['input']>;
  address_contains?: InputMaybe<Scalars['String']['input']>;
  address_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  address_ends_with?: InputMaybe<Scalars['String']['input']>;
  address_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  address_gt?: InputMaybe<Scalars['String']['input']>;
  address_gte?: InputMaybe<Scalars['String']['input']>;
  address_in?: InputMaybe<Array<Scalars['String']['input']>>;
  address_lt?: InputMaybe<Scalars['String']['input']>;
  address_lte?: InputMaybe<Scalars['String']['input']>;
  address_not?: InputMaybe<Scalars['String']['input']>;
  address_not_contains?: InputMaybe<Scalars['String']['input']>;
  address_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  address_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  address_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  address_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  address_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  address_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  address_starts_with?: InputMaybe<Scalars['String']['input']>;
  address_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  and?: InputMaybe<Array<InputMaybe<PoolTokenFilter>>>;
  balance?: InputMaybe<Scalars['BigDecimal']['input']>;
  balance_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  balance_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  balance_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  balance_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  balance_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  balance_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  balance_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  decimals?: InputMaybe<Scalars['Int']['input']>;
  decimals_gt?: InputMaybe<Scalars['Int']['input']>;
  decimals_gte?: InputMaybe<Scalars['Int']['input']>;
  decimals_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  decimals_lt?: InputMaybe<Scalars['Int']['input']>;
  decimals_lte?: InputMaybe<Scalars['Int']['input']>;
  decimals_not?: InputMaybe<Scalars['Int']['input']>;
  decimals_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  denormWeight?: InputMaybe<Scalars['BigDecimal']['input']>;
  denormWeight_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  denormWeight_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  denormWeight_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  denormWeight_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  denormWeight_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  denormWeight_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  denormWeight_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<PoolTokenFilter>>>;
  poolId?: InputMaybe<Scalars['String']['input']>;
  poolId_?: InputMaybe<PoolFilter>;
  poolId_contains?: InputMaybe<Scalars['String']['input']>;
  poolId_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  poolId_ends_with?: InputMaybe<Scalars['String']['input']>;
  poolId_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolId_gt?: InputMaybe<Scalars['String']['input']>;
  poolId_gte?: InputMaybe<Scalars['String']['input']>;
  poolId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  poolId_lt?: InputMaybe<Scalars['String']['input']>;
  poolId_lte?: InputMaybe<Scalars['String']['input']>;
  poolId_not?: InputMaybe<Scalars['String']['input']>;
  poolId_not_contains?: InputMaybe<Scalars['String']['input']>;
  poolId_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  poolId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  poolId_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolId_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  poolId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  poolId_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolId_starts_with?: InputMaybe<Scalars['String']['input']>;
  poolId_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  symbol_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_gt?: InputMaybe<Scalars['String']['input']>;
  symbol_gte?: InputMaybe<Scalars['String']['input']>;
  symbol_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_lt?: InputMaybe<Scalars['String']['input']>;
  symbol_lte?: InputMaybe<Scalars['String']['input']>;
  symbol_not?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  xToken?: InputMaybe<Scalars['String']['input']>;
  xToken_?: InputMaybe<XTokenFilter>;
  xToken_contains?: InputMaybe<Scalars['String']['input']>;
  xToken_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  xToken_ends_with?: InputMaybe<Scalars['String']['input']>;
  xToken_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  xToken_gt?: InputMaybe<Scalars['String']['input']>;
  xToken_gte?: InputMaybe<Scalars['String']['input']>;
  xToken_in?: InputMaybe<Array<Scalars['String']['input']>>;
  xToken_lt?: InputMaybe<Scalars['String']['input']>;
  xToken_lte?: InputMaybe<Scalars['String']['input']>;
  xToken_not?: InputMaybe<Scalars['String']['input']>;
  xToken_not_contains?: InputMaybe<Scalars['String']['input']>;
  xToken_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  xToken_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  xToken_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  xToken_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  xToken_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  xToken_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  xToken_starts_with?: InputMaybe<Scalars['String']['input']>;
  xToken_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum PoolTokenOrderBy {
  Address = 'address',
  Balance = 'balance',
  Decimals = 'decimals',
  DenormWeight = 'denormWeight',
  Id = 'id',
  Name = 'name',
  PoolId = 'poolId',
  PoolIdActive = 'poolId__active',
  PoolIdAddTokenTimeLockInBlocks = 'poolId__addTokenTimeLockInBlocks',
  PoolIdCap = 'poolId__cap',
  PoolIdController = 'poolId__controller',
  PoolIdCreateTime = 'poolId__createTime',
  PoolIdCrp = 'poolId__crp',
  PoolIdCrpController = 'poolId__crpController',
  PoolIdExitsCount = 'poolId__exitsCount',
  PoolIdFinalized = 'poolId__finalized',
  PoolIdHoldersCount = 'poolId__holdersCount',
  PoolIdId = 'poolId__id',
  PoolIdJoinsCount = 'poolId__joinsCount',
  PoolIdLiquidity = 'poolId__liquidity',
  PoolIdLogAddress = 'poolId__logAddress',
  PoolIdMinimumWeightChangeBlockPeriod = 'poolId__minimumWeightChangeBlockPeriod',
  PoolIdName = 'poolId__name',
  PoolIdPublicSwap = 'poolId__publicSwap',
  PoolIdSwapFee = 'poolId__swapFee',
  PoolIdSwapsCount = 'poolId__swapsCount',
  PoolIdSymbol = 'poolId__symbol',
  PoolIdTokensCount = 'poolId__tokensCount',
  PoolIdTotalShares = 'poolId__totalShares',
  PoolIdTotalSwapFee = 'poolId__totalSwapFee',
  PoolIdTotalSwapVolume = 'poolId__totalSwapVolume',
  PoolIdTotalWeight = 'poolId__totalWeight',
  PoolIdTx = 'poolId__tx',
  Symbol = 'symbol',
  XToken = 'xToken',
  XTokenDecimals = 'xToken__decimals',
  XTokenId = 'xToken__id',
  XTokenIsLpt = 'xToken__isLPT',
  XTokenName = 'xToken__name',
  XTokenPaused = 'xToken__paused',
  XTokenSymbol = 'xToken__symbol'
}

export type PoolFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  active_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  active_not?: InputMaybe<Scalars['Boolean']['input']>;
  active_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  addTokenTimeLockInBlocks?: InputMaybe<Scalars['BigInt']['input']>;
  addTokenTimeLockInBlocks_gt?: InputMaybe<Scalars['BigInt']['input']>;
  addTokenTimeLockInBlocks_gte?: InputMaybe<Scalars['BigInt']['input']>;
  addTokenTimeLockInBlocks_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  addTokenTimeLockInBlocks_lt?: InputMaybe<Scalars['BigInt']['input']>;
  addTokenTimeLockInBlocks_lte?: InputMaybe<Scalars['BigInt']['input']>;
  addTokenTimeLockInBlocks_not?: InputMaybe<Scalars['BigInt']['input']>;
  addTokenTimeLockInBlocks_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  and?: InputMaybe<Array<InputMaybe<PoolFilter>>>;
  cap?: InputMaybe<Scalars['BigInt']['input']>;
  cap_gt?: InputMaybe<Scalars['BigInt']['input']>;
  cap_gte?: InputMaybe<Scalars['BigInt']['input']>;
  cap_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  cap_lt?: InputMaybe<Scalars['BigInt']['input']>;
  cap_lte?: InputMaybe<Scalars['BigInt']['input']>;
  cap_not?: InputMaybe<Scalars['BigInt']['input']>;
  cap_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  controller?: InputMaybe<Scalars['Bytes']['input']>;
  controller_contains?: InputMaybe<Scalars['Bytes']['input']>;
  controller_gt?: InputMaybe<Scalars['Bytes']['input']>;
  controller_gte?: InputMaybe<Scalars['Bytes']['input']>;
  controller_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  controller_lt?: InputMaybe<Scalars['Bytes']['input']>;
  controller_lte?: InputMaybe<Scalars['Bytes']['input']>;
  controller_not?: InputMaybe<Scalars['Bytes']['input']>;
  controller_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  controller_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  createTime?: InputMaybe<Scalars['Int']['input']>;
  createTime_gt?: InputMaybe<Scalars['Int']['input']>;
  createTime_gte?: InputMaybe<Scalars['Int']['input']>;
  createTime_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  createTime_lt?: InputMaybe<Scalars['Int']['input']>;
  createTime_lte?: InputMaybe<Scalars['Int']['input']>;
  createTime_not?: InputMaybe<Scalars['Int']['input']>;
  createTime_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  crp?: InputMaybe<Scalars['Boolean']['input']>;
  crpController?: InputMaybe<Scalars['Bytes']['input']>;
  crpController_contains?: InputMaybe<Scalars['Bytes']['input']>;
  crpController_gt?: InputMaybe<Scalars['Bytes']['input']>;
  crpController_gte?: InputMaybe<Scalars['Bytes']['input']>;
  crpController_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  crpController_lt?: InputMaybe<Scalars['Bytes']['input']>;
  crpController_lte?: InputMaybe<Scalars['Bytes']['input']>;
  crpController_not?: InputMaybe<Scalars['Bytes']['input']>;
  crpController_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  crpController_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  crp_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  crp_not?: InputMaybe<Scalars['Boolean']['input']>;
  crp_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  crpoolGradualWeightsUpdate?: InputMaybe<Scalars['String']['input']>;
  crpoolGradualWeightsUpdate_?: InputMaybe<CrPoolGradualWeightsUpdateFilter>;
  crpoolGradualWeightsUpdate_contains?: InputMaybe<Scalars['String']['input']>;
  crpoolGradualWeightsUpdate_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  crpoolGradualWeightsUpdate_ends_with?: InputMaybe<Scalars['String']['input']>;
  crpoolGradualWeightsUpdate_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  crpoolGradualWeightsUpdate_gt?: InputMaybe<Scalars['String']['input']>;
  crpoolGradualWeightsUpdate_gte?: InputMaybe<Scalars['String']['input']>;
  crpoolGradualWeightsUpdate_in?: InputMaybe<Array<Scalars['String']['input']>>;
  crpoolGradualWeightsUpdate_lt?: InputMaybe<Scalars['String']['input']>;
  crpoolGradualWeightsUpdate_lte?: InputMaybe<Scalars['String']['input']>;
  crpoolGradualWeightsUpdate_not?: InputMaybe<Scalars['String']['input']>;
  crpoolGradualWeightsUpdate_not_contains?: InputMaybe<Scalars['String']['input']>;
  crpoolGradualWeightsUpdate_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  crpoolGradualWeightsUpdate_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  crpoolGradualWeightsUpdate_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  crpoolGradualWeightsUpdate_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  crpoolGradualWeightsUpdate_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  crpoolGradualWeightsUpdate_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  crpoolGradualWeightsUpdate_starts_with?: InputMaybe<Scalars['String']['input']>;
  crpoolGradualWeightsUpdate_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  exitsCount?: InputMaybe<Scalars['BigInt']['input']>;
  exitsCount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  exitsCount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  exitsCount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  exitsCount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  exitsCount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  exitsCount_not?: InputMaybe<Scalars['BigInt']['input']>;
  exitsCount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  factoryID?: InputMaybe<Scalars['String']['input']>;
  factoryID_?: InputMaybe<BalancerFilter>;
  factoryID_contains?: InputMaybe<Scalars['String']['input']>;
  factoryID_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  factoryID_ends_with?: InputMaybe<Scalars['String']['input']>;
  factoryID_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  factoryID_gt?: InputMaybe<Scalars['String']['input']>;
  factoryID_gte?: InputMaybe<Scalars['String']['input']>;
  factoryID_in?: InputMaybe<Array<Scalars['String']['input']>>;
  factoryID_lt?: InputMaybe<Scalars['String']['input']>;
  factoryID_lte?: InputMaybe<Scalars['String']['input']>;
  factoryID_not?: InputMaybe<Scalars['String']['input']>;
  factoryID_not_contains?: InputMaybe<Scalars['String']['input']>;
  factoryID_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  factoryID_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  factoryID_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  factoryID_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  factoryID_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  factoryID_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  factoryID_starts_with?: InputMaybe<Scalars['String']['input']>;
  factoryID_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  finalized?: InputMaybe<Scalars['Boolean']['input']>;
  finalized_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  finalized_not?: InputMaybe<Scalars['Boolean']['input']>;
  finalized_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  holders?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  holdersCount?: InputMaybe<Scalars['BigInt']['input']>;
  holdersCount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  holdersCount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  holdersCount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  holdersCount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  holdersCount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  holdersCount_not?: InputMaybe<Scalars['BigInt']['input']>;
  holdersCount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  holders_contains?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  holders_contains_nocase?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  holders_not?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  holders_not_contains?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  holders_not_contains_nocase?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  joinsCount?: InputMaybe<Scalars['BigInt']['input']>;
  joinsCount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  joinsCount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  joinsCount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  joinsCount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  joinsCount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  joinsCount_not?: InputMaybe<Scalars['BigInt']['input']>;
  joinsCount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  liquidity?: InputMaybe<Scalars['BigDecimal']['input']>;
  liquidityPoolToken?: InputMaybe<Scalars['String']['input']>;
  liquidityPoolToken_?: InputMaybe<TokenFilter>;
  liquidityPoolToken_contains?: InputMaybe<Scalars['String']['input']>;
  liquidityPoolToken_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidityPoolToken_ends_with?: InputMaybe<Scalars['String']['input']>;
  liquidityPoolToken_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidityPoolToken_gt?: InputMaybe<Scalars['String']['input']>;
  liquidityPoolToken_gte?: InputMaybe<Scalars['String']['input']>;
  liquidityPoolToken_in?: InputMaybe<Array<Scalars['String']['input']>>;
  liquidityPoolToken_lt?: InputMaybe<Scalars['String']['input']>;
  liquidityPoolToken_lte?: InputMaybe<Scalars['String']['input']>;
  liquidityPoolToken_not?: InputMaybe<Scalars['String']['input']>;
  liquidityPoolToken_not_contains?: InputMaybe<Scalars['String']['input']>;
  liquidityPoolToken_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidityPoolToken_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  liquidityPoolToken_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidityPoolToken_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  liquidityPoolToken_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  liquidityPoolToken_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidityPoolToken_starts_with?: InputMaybe<Scalars['String']['input']>;
  liquidityPoolToken_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  liquidity_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  liquidity_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  liquidity_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  liquidity_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  liquidity_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  liquidity_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  liquidity_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  logAddress?: InputMaybe<Scalars['Bytes']['input']>;
  logAddress_contains?: InputMaybe<Scalars['Bytes']['input']>;
  logAddress_gt?: InputMaybe<Scalars['Bytes']['input']>;
  logAddress_gte?: InputMaybe<Scalars['Bytes']['input']>;
  logAddress_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  logAddress_lt?: InputMaybe<Scalars['Bytes']['input']>;
  logAddress_lte?: InputMaybe<Scalars['Bytes']['input']>;
  logAddress_not?: InputMaybe<Scalars['Bytes']['input']>;
  logAddress_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  logAddress_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  minimumWeightChangeBlockPeriod?: InputMaybe<Scalars['BigInt']['input']>;
  minimumWeightChangeBlockPeriod_gt?: InputMaybe<Scalars['BigInt']['input']>;
  minimumWeightChangeBlockPeriod_gte?: InputMaybe<Scalars['BigInt']['input']>;
  minimumWeightChangeBlockPeriod_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  minimumWeightChangeBlockPeriod_lt?: InputMaybe<Scalars['BigInt']['input']>;
  minimumWeightChangeBlockPeriod_lte?: InputMaybe<Scalars['BigInt']['input']>;
  minimumWeightChangeBlockPeriod_not?: InputMaybe<Scalars['BigInt']['input']>;
  minimumWeightChangeBlockPeriod_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  newCRPoolToken?: InputMaybe<Scalars['String']['input']>;
  newCRPoolToken_?: InputMaybe<NewCrPoolTokenFilter>;
  newCRPoolToken_contains?: InputMaybe<Scalars['String']['input']>;
  newCRPoolToken_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  newCRPoolToken_ends_with?: InputMaybe<Scalars['String']['input']>;
  newCRPoolToken_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  newCRPoolToken_gt?: InputMaybe<Scalars['String']['input']>;
  newCRPoolToken_gte?: InputMaybe<Scalars['String']['input']>;
  newCRPoolToken_in?: InputMaybe<Array<Scalars['String']['input']>>;
  newCRPoolToken_lt?: InputMaybe<Scalars['String']['input']>;
  newCRPoolToken_lte?: InputMaybe<Scalars['String']['input']>;
  newCRPoolToken_not?: InputMaybe<Scalars['String']['input']>;
  newCRPoolToken_not_contains?: InputMaybe<Scalars['String']['input']>;
  newCRPoolToken_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  newCRPoolToken_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  newCRPoolToken_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  newCRPoolToken_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  newCRPoolToken_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  newCRPoolToken_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  newCRPoolToken_starts_with?: InputMaybe<Scalars['String']['input']>;
  newCRPoolToken_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<PoolFilter>>>;
  publicSwap?: InputMaybe<Scalars['Boolean']['input']>;
  publicSwap_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  publicSwap_not?: InputMaybe<Scalars['Boolean']['input']>;
  publicSwap_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  rights?: InputMaybe<Array<Scalars['String']['input']>>;
  rights_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  rights_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  rights_not?: InputMaybe<Array<Scalars['String']['input']>>;
  rights_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  rights_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  shares_?: InputMaybe<PoolShareFilter>;
  swapFee?: InputMaybe<Scalars['BigDecimal']['input']>;
  swapFee_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  swapFee_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  swapFee_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  swapFee_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  swapFee_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  swapFee_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  swapFee_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  swapsCount?: InputMaybe<Scalars['BigInt']['input']>;
  swapsCount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  swapsCount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  swapsCount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  swapsCount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  swapsCount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  swapsCount_not?: InputMaybe<Scalars['BigInt']['input']>;
  swapsCount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  swaps_?: InputMaybe<SwapFilter>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  symbol_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_gt?: InputMaybe<Scalars['String']['input']>;
  symbol_gte?: InputMaybe<Scalars['String']['input']>;
  symbol_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_lt?: InputMaybe<Scalars['String']['input']>;
  symbol_lte?: InputMaybe<Scalars['String']['input']>;
  symbol_not?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokensCount?: InputMaybe<Scalars['BigInt']['input']>;
  tokensCount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  tokensCount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  tokensCount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tokensCount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  tokensCount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  tokensCount_not?: InputMaybe<Scalars['BigInt']['input']>;
  tokensCount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  tokensList?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  tokensList_contains?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  tokensList_contains_nocase?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  tokensList_not?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  tokensList_not_contains?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  tokensList_not_contains_nocase?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  tokens_?: InputMaybe<PoolTokenFilter>;
  totalShares?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalShares_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalShares_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalShares_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalShares_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalShares_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalShares_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalShares_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalSwapFee?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalSwapFee_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalSwapFee_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalSwapFee_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalSwapFee_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalSwapFee_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalSwapFee_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalSwapFee_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalSwapVolume?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalSwapVolume_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalSwapVolume_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalSwapVolume_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalSwapVolume_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalSwapVolume_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalSwapVolume_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalSwapVolume_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalWeight?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalWeight_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalWeight_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalWeight_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  totalWeight_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalWeight_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalWeight_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  totalWeight_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  tx?: InputMaybe<Scalars['Bytes']['input']>;
  tx_contains?: InputMaybe<Scalars['Bytes']['input']>;
  tx_gt?: InputMaybe<Scalars['Bytes']['input']>;
  tx_gte?: InputMaybe<Scalars['Bytes']['input']>;
  tx_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  tx_lt?: InputMaybe<Scalars['Bytes']['input']>;
  tx_lte?: InputMaybe<Scalars['Bytes']['input']>;
  tx_not?: InputMaybe<Scalars['Bytes']['input']>;
  tx_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  tx_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  whitelist?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  whitelist_contains?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  whitelist_contains_nocase?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  whitelist_not?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  whitelist_not_contains?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  whitelist_not_contains_nocase?: InputMaybe<Array<Scalars['Bytes']['input']>>;
};

export enum PoolOrderBy {
  Active = 'active',
  AddTokenTimeLockInBlocks = 'addTokenTimeLockInBlocks',
  Cap = 'cap',
  Controller = 'controller',
  CreateTime = 'createTime',
  Crp = 'crp',
  CrpController = 'crpController',
  CrpoolGradualWeightsUpdate = 'crpoolGradualWeightsUpdate',
  CrpoolGradualWeightsUpdateEndBlock = 'crpoolGradualWeightsUpdate__endBlock',
  CrpoolGradualWeightsUpdateId = 'crpoolGradualWeightsUpdate__id',
  CrpoolGradualWeightsUpdateStartBlock = 'crpoolGradualWeightsUpdate__startBlock',
  ExitsCount = 'exitsCount',
  FactoryId = 'factoryID',
  FactoryIdColor = 'factoryID__color',
  FactoryIdCrpCount = 'factoryID__crpCount',
  FactoryIdFinalizedPoolCount = 'factoryID__finalizedPoolCount',
  FactoryIdId = 'factoryID__id',
  FactoryIdPoolCount = 'factoryID__poolCount',
  FactoryIdPrivateCount = 'factoryID__privateCount',
  FactoryIdTotalLiquidity = 'factoryID__totalLiquidity',
  FactoryIdTotalSwapFee = 'factoryID__totalSwapFee',
  FactoryIdTotalSwapVolume = 'factoryID__totalSwapVolume',
  FactoryIdTxCount = 'factoryID__txCount',
  Finalized = 'finalized',
  Holders = 'holders',
  HoldersCount = 'holdersCount',
  Id = 'id',
  JoinsCount = 'joinsCount',
  Liquidity = 'liquidity',
  LiquidityPoolToken = 'liquidityPoolToken',
  LiquidityPoolTokenDecimals = 'liquidityPoolToken__decimals',
  LiquidityPoolTokenId = 'liquidityPoolToken__id',
  LiquidityPoolTokenIsLpt = 'liquidityPoolToken__isLPT',
  LiquidityPoolTokenName = 'liquidityPoolToken__name',
  LiquidityPoolTokenPaused = 'liquidityPoolToken__paused',
  LiquidityPoolTokenSymbol = 'liquidityPoolToken__symbol',
  LiquidityPoolTokenTvl = 'liquidityPoolToken__tvl',
  LogAddress = 'logAddress',
  MinimumWeightChangeBlockPeriod = 'minimumWeightChangeBlockPeriod',
  Name = 'name',
  NewCrPoolToken = 'newCRPoolToken',
  NewCrPoolTokenBalance = 'newCRPoolToken__balance',
  NewCrPoolTokenCommitBlock = 'newCRPoolToken__commitBlock',
  NewCrPoolTokenDenormWeight = 'newCRPoolToken__denormWeight',
  NewCrPoolTokenId = 'newCRPoolToken__id',
  PublicSwap = 'publicSwap',
  Rights = 'rights',
  Shares = 'shares',
  SwapFee = 'swapFee',
  Swaps = 'swaps',
  SwapsCount = 'swapsCount',
  Symbol = 'symbol',
  Tokens = 'tokens',
  TokensCount = 'tokensCount',
  TokensList = 'tokensList',
  TotalShares = 'totalShares',
  TotalSwapFee = 'totalSwapFee',
  TotalSwapVolume = 'totalSwapVolume',
  TotalWeight = 'totalWeight',
  Tx = 'tx',
  Whitelist = 'whitelist'
}

export type Query = {
  __typename?: 'Query';
  /** Access to subgraph metadata */
  _meta?: Maybe<Meta>;
  assetToken?: Maybe<AssetToken>;
  assetTokenData?: Maybe<AssetTokenData>;
  assetTokenDatas: Array<AssetTokenData>;
  assetTokenFactories: Array<AssetTokenFactory>;
  assetTokenFactory?: Maybe<AssetTokenFactory>;
  assetTokenIssuer?: Maybe<AssetTokenIssuer>;
  assetTokenIssuers: Array<AssetTokenIssuer>;
  assetTokens: Array<AssetToken>;
  balancer?: Maybe<Balancer>;
  balancers: Array<Balancer>;
  crpControllerPoolCount?: Maybe<CrpControllerPoolCount>;
  crpControllerPoolCounts: Array<CrpControllerPoolCount>;
  crpool?: Maybe<CrPool>;
  crpoolGradualWeightsUpdate?: Maybe<CrPoolGradualWeightsUpdate>;
  crpoolGradualWeightsUpdates: Array<CrPoolGradualWeightsUpdate>;
  crpools: Array<CrPool>;
  dotcasset?: Maybe<DotcAsset>;
  dotcassets: Array<DotcAsset>;
  erc20Token?: Maybe<Erc20Token>;
  erc20Tokens: Array<Erc20Token>;
  erc1155Token?: Maybe<Erc1155Token>;
  erc1155Tokens: Array<Erc1155Token>;
  kyaData?: Maybe<KyaData>;
  kyaDatas: Array<KyaData>;
  newCRPoolToken?: Maybe<NewCrPoolToken>;
  newCRPoolTokens: Array<NewCrPoolToken>;
  offer?: Maybe<Offer>;
  offers: Array<Offer>;
  openOffer?: Maybe<OpenOffer>;
  openOffers: Array<OpenOffer>;
  openOrder?: Maybe<OpenOrder>;
  openOrders: Array<OpenOrder>;
  order?: Maybe<Order>;
  orders: Array<Order>;
  pool?: Maybe<Pool>;
  poolShare?: Maybe<PoolShare>;
  poolShares: Array<PoolShare>;
  poolToken?: Maybe<PoolToken>;
  poolTokens: Array<PoolToken>;
  pools: Array<Pool>;
  securities: Array<Security>;
  security?: Maybe<Security>;
  swap?: Maybe<Swap>;
  swapOperation?: Maybe<SwapOperation>;
  swapOperations: Array<SwapOperation>;
  swaps: Array<Swap>;
  swarmStake?: Maybe<SwarmStake>;
  swarmStakes: Array<SwarmStake>;
  token?: Maybe<Token>;
  tokenPrice?: Maybe<TokenPrice>;
  tokenPrices: Array<TokenPrice>;
  tokens: Array<Token>;
  transaction?: Maybe<Transaction>;
  transactions: Array<Transaction>;
  user?: Maybe<User>;
  users: Array<User>;
  xtoken?: Maybe<XToken>;
  xtokens: Array<XToken>;
};


export type QueryMetaArgs = {
  block?: InputMaybe<BlockHeight>;
};


export type QueryAssetTokenArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QueryAssetTokenDataArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QueryAssetTokenDatasArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AssetTokenDataOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<AssetTokenDataFilter>;
};


export type QueryAssetTokenFactoriesArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AssetTokenFactoryOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<AssetTokenFactoryFilter>;
};


export type QueryAssetTokenFactoryArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QueryAssetTokenIssuerArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QueryAssetTokenIssuersArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AssetTokenIssuerOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<AssetTokenIssuerFilter>;
};


export type QueryAssetTokensArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AssetTokenOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<AssetTokenFilter>;
};


export type QueryBalancerArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QueryBalancersArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BalancerOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<BalancerFilter>;
};


export type QueryCrpControllerPoolCountArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QueryCrpControllerPoolCountsArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CrpControllerPoolCountOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<CrpControllerPoolCountFilter>;
};


export type QueryCrpoolArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QueryCrpoolGradualWeightsUpdateArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QueryCrpoolGradualWeightsUpdatesArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CrPoolGradualWeightsUpdateOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<CrPoolGradualWeightsUpdateFilter>;
};


export type QueryCrpoolsArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CrPoolOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<CrPoolFilter>;
};


export type QueryDotcassetArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QueryDotcassetsArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DotcAssetOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<DotcAssetFilter>;
};


export type QueryErc20TokenArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QueryErc20TokensArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Erc20TokenOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<Erc20TokenFilter>;
};


export type QueryErc1155TokenArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QueryErc1155TokensArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Erc1155TokenOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<Erc1155TokenFilter>;
};


export type QueryKyaDataArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QueryKyaDatasArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<KyaDataOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<KyaDataFilter>;
};


export type QueryNewCrPoolTokenArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QueryNewCrPoolTokensArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<NewCrPoolTokenOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<NewCrPoolTokenFilter>;
};


export type QueryOfferArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QueryOffersArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OfferOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<OfferFilter>;
};


export type QueryOpenOfferArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QueryOpenOffersArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OpenOfferOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<OpenOfferFilter>;
};


export type QueryOpenOrderArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QueryOpenOrdersArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OpenOrderOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<OpenOrderFilter>;
};


export type QueryOrderArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QueryOrdersArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<OrderFilter>;
};


export type QueryPoolArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QueryPoolShareArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QueryPoolSharesArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolShareOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<PoolShareFilter>;
};


export type QueryPoolTokenArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QueryPoolTokensArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolTokenOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<PoolTokenFilter>;
};


export type QueryPoolsArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<PoolFilter>;
};


export type QuerySecuritiesArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SecurityOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<SecurityFilter>;
};


export type QuerySecurityArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QuerySwapArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QuerySwapOperationArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QuerySwapOperationsArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SwapOperationOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<SwapOperationFilter>;
};


export type QuerySwapsArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SwapOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<SwapFilter>;
};


export type QuerySwarmStakeArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QuerySwarmStakesArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SwarmStakeOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<SwarmStakeFilter>;
};


export type QueryTokenArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QueryTokenPriceArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QueryTokenPricesArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TokenPriceOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<TokenPriceFilter>;
};


export type QueryTokensArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TokenOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<TokenFilter>;
};


export type QueryTransactionArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QueryTransactionsArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TransactionOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<TransactionFilter>;
};


export type QueryUserArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QueryUsersArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<UserFilter>;
};


export type QueryXtokenArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type QueryXtokensArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<XTokenOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<XTokenFilter>;
};

export type Security = {
  __typename?: 'Security';
  id: Scalars['ID']['output'];
  sender: Scalars['Bytes']['output'];
  smtStaked: Scalars['BigDecimal']['output'];
  stakes: Array<SwarmStake>;
  token: Token;
};


export type SecurityStakesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SwarmStakeOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SwarmStakeFilter>;
};

export type SecurityFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<SecurityFilter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<SecurityFilter>>>;
  sender?: InputMaybe<Scalars['Bytes']['input']>;
  sender_contains?: InputMaybe<Scalars['Bytes']['input']>;
  sender_gt?: InputMaybe<Scalars['Bytes']['input']>;
  sender_gte?: InputMaybe<Scalars['Bytes']['input']>;
  sender_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  sender_lt?: InputMaybe<Scalars['Bytes']['input']>;
  sender_lte?: InputMaybe<Scalars['Bytes']['input']>;
  sender_not?: InputMaybe<Scalars['Bytes']['input']>;
  sender_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  sender_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  smtStaked?: InputMaybe<Scalars['BigDecimal']['input']>;
  smtStaked_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  smtStaked_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  smtStaked_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  smtStaked_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  smtStaked_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  smtStaked_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  smtStaked_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  stakes_?: InputMaybe<SwarmStakeFilter>;
  token?: InputMaybe<Scalars['String']['input']>;
  token_?: InputMaybe<TokenFilter>;
  token_contains?: InputMaybe<Scalars['String']['input']>;
  token_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token_ends_with?: InputMaybe<Scalars['String']['input']>;
  token_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token_gt?: InputMaybe<Scalars['String']['input']>;
  token_gte?: InputMaybe<Scalars['String']['input']>;
  token_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token_lt?: InputMaybe<Scalars['String']['input']>;
  token_lte?: InputMaybe<Scalars['String']['input']>;
  token_not?: InputMaybe<Scalars['String']['input']>;
  token_not_contains?: InputMaybe<Scalars['String']['input']>;
  token_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  token_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  token_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token_starts_with?: InputMaybe<Scalars['String']['input']>;
  token_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum SecurityOrderBy {
  Id = 'id',
  Sender = 'sender',
  SmtStaked = 'smtStaked',
  Stakes = 'stakes',
  Token = 'token',
  TokenDecimals = 'token__decimals',
  TokenId = 'token__id',
  TokenIsLpt = 'token__isLPT',
  TokenName = 'token__name',
  TokenPaused = 'token__paused',
  TokenSymbol = 'token__symbol',
  TokenTvl = 'token__tvl'
}

export type Subscription = {
  __typename?: 'Subscription';
  /** Access to subgraph metadata */
  _meta?: Maybe<Meta>;
  assetToken?: Maybe<AssetToken>;
  assetTokenData?: Maybe<AssetTokenData>;
  assetTokenDatas: Array<AssetTokenData>;
  assetTokenFactories: Array<AssetTokenFactory>;
  assetTokenFactory?: Maybe<AssetTokenFactory>;
  assetTokenIssuer?: Maybe<AssetTokenIssuer>;
  assetTokenIssuers: Array<AssetTokenIssuer>;
  assetTokens: Array<AssetToken>;
  balancer?: Maybe<Balancer>;
  balancers: Array<Balancer>;
  crpControllerPoolCount?: Maybe<CrpControllerPoolCount>;
  crpControllerPoolCounts: Array<CrpControllerPoolCount>;
  crpool?: Maybe<CrPool>;
  crpoolGradualWeightsUpdate?: Maybe<CrPoolGradualWeightsUpdate>;
  crpoolGradualWeightsUpdates: Array<CrPoolGradualWeightsUpdate>;
  crpools: Array<CrPool>;
  dotcasset?: Maybe<DotcAsset>;
  dotcassets: Array<DotcAsset>;
  erc20Token?: Maybe<Erc20Token>;
  erc20Tokens: Array<Erc20Token>;
  erc1155Token?: Maybe<Erc1155Token>;
  erc1155Tokens: Array<Erc1155Token>;
  kyaData?: Maybe<KyaData>;
  kyaDatas: Array<KyaData>;
  newCRPoolToken?: Maybe<NewCrPoolToken>;
  newCRPoolTokens: Array<NewCrPoolToken>;
  offer?: Maybe<Offer>;
  offers: Array<Offer>;
  openOffer?: Maybe<OpenOffer>;
  openOffers: Array<OpenOffer>;
  openOrder?: Maybe<OpenOrder>;
  openOrders: Array<OpenOrder>;
  order?: Maybe<Order>;
  orders: Array<Order>;
  pool?: Maybe<Pool>;
  poolShare?: Maybe<PoolShare>;
  poolShares: Array<PoolShare>;
  poolToken?: Maybe<PoolToken>;
  poolTokens: Array<PoolToken>;
  pools: Array<Pool>;
  securities: Array<Security>;
  security?: Maybe<Security>;
  swap?: Maybe<Swap>;
  swapOperation?: Maybe<SwapOperation>;
  swapOperations: Array<SwapOperation>;
  swaps: Array<Swap>;
  swarmStake?: Maybe<SwarmStake>;
  swarmStakes: Array<SwarmStake>;
  token?: Maybe<Token>;
  tokenPrice?: Maybe<TokenPrice>;
  tokenPrices: Array<TokenPrice>;
  tokens: Array<Token>;
  transaction?: Maybe<Transaction>;
  transactions: Array<Transaction>;
  user?: Maybe<User>;
  users: Array<User>;
  xtoken?: Maybe<XToken>;
  xtokens: Array<XToken>;
};


export type SubscriptionMetaArgs = {
  block?: InputMaybe<BlockHeight>;
};


export type SubscriptionAssetTokenArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionAssetTokenDataArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionAssetTokenDatasArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AssetTokenDataOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<AssetTokenDataFilter>;
};


export type SubscriptionAssetTokenFactoriesArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AssetTokenFactoryOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<AssetTokenFactoryFilter>;
};


export type SubscriptionAssetTokenFactoryArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionAssetTokenIssuerArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionAssetTokenIssuersArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AssetTokenIssuerOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<AssetTokenIssuerFilter>;
};


export type SubscriptionAssetTokensArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AssetTokenOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<AssetTokenFilter>;
};


export type SubscriptionBalancerArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionBalancersArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BalancerOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<BalancerFilter>;
};


export type SubscriptionCrpControllerPoolCountArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionCrpControllerPoolCountsArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CrpControllerPoolCountOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<CrpControllerPoolCountFilter>;
};


export type SubscriptionCrpoolArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionCrpoolGradualWeightsUpdateArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionCrpoolGradualWeightsUpdatesArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CrPoolGradualWeightsUpdateOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<CrPoolGradualWeightsUpdateFilter>;
};


export type SubscriptionCrpoolsArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CrPoolOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<CrPoolFilter>;
};


export type SubscriptionDotcassetArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionDotcassetsArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DotcAssetOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<DotcAssetFilter>;
};


export type SubscriptionErc20TokenArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionErc20TokensArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Erc20TokenOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<Erc20TokenFilter>;
};


export type SubscriptionErc1155TokenArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionErc1155TokensArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Erc1155TokenOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<Erc1155TokenFilter>;
};


export type SubscriptionKyaDataArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionKyaDatasArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<KyaDataOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<KyaDataFilter>;
};


export type SubscriptionNewCrPoolTokenArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionNewCrPoolTokensArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<NewCrPoolTokenOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<NewCrPoolTokenFilter>;
};


export type SubscriptionOfferArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionOffersArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OfferOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<OfferFilter>;
};


export type SubscriptionOpenOfferArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionOpenOffersArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OpenOfferOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<OpenOfferFilter>;
};


export type SubscriptionOpenOrderArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionOpenOrdersArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OpenOrderOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<OpenOrderFilter>;
};


export type SubscriptionOrderArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionOrdersArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<OrderFilter>;
};


export type SubscriptionPoolArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionPoolShareArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionPoolSharesArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolShareOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<PoolShareFilter>;
};


export type SubscriptionPoolTokenArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionPoolTokensArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolTokenOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<PoolTokenFilter>;
};


export type SubscriptionPoolsArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<PoolFilter>;
};


export type SubscriptionSecuritiesArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SecurityOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<SecurityFilter>;
};


export type SubscriptionSecurityArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionSwapArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionSwapOperationArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionSwapOperationsArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SwapOperationOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<SwapOperationFilter>;
};


export type SubscriptionSwapsArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SwapOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<SwapFilter>;
};


export type SubscriptionSwarmStakeArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionSwarmStakesArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SwarmStakeOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<SwarmStakeFilter>;
};


export type SubscriptionTokenArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionTokenPriceArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionTokenPricesArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TokenPriceOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<TokenPriceFilter>;
};


export type SubscriptionTokensArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TokenOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<TokenFilter>;
};


export type SubscriptionTransactionArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionTransactionsArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TransactionOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<TransactionFilter>;
};


export type SubscriptionUserArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionUsersArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<UserFilter>;
};


export type SubscriptionXtokenArgs = {
  block?: InputMaybe<BlockHeight>;
  id: Scalars['ID']['input'];
  subgraphError?: SubgraphErrorPolicy;
};


export type SubscriptionXtokensArgs = {
  block?: InputMaybe<BlockHeight>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<XTokenOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  subgraphError?: SubgraphErrorPolicy;
  where?: InputMaybe<XTokenFilter>;
};

export type Swap = {
  __typename?: 'Swap';
  caller: Scalars['Bytes']['output'];
  feeValue: Scalars['BigDecimal']['output'];
  id: Scalars['ID']['output'];
  poolAddress: Pool;
  poolLiquidity: Scalars['BigDecimal']['output'];
  poolTotalSwapFee: Scalars['BigDecimal']['output'];
  poolTotalSwapVolume: Scalars['BigDecimal']['output'];
  swapOperation: SwapOperation;
  timestamp: Scalars['Int']['output'];
  tokenAmountIn: Scalars['BigDecimal']['output'];
  tokenAmountOut: Scalars['BigDecimal']['output'];
  tokenIn: Scalars['Bytes']['output'];
  tokenInSym: Scalars['String']['output'];
  tokenOut: Scalars['Bytes']['output'];
  tokenOutSym: Scalars['String']['output'];
  userAddress?: Maybe<User>;
  value: Scalars['BigDecimal']['output'];
};

export type SwapOperation = {
  __typename?: 'SwapOperation';
  caller: Scalars['Bytes']['output'];
  feeValue: Scalars['BigDecimal']['output'];
  id: Scalars['ID']['output'];
  partialSwapIds: Array<Scalars['String']['output']>;
  partialSwaps: Array<Swap>;
  partialSwapsCount: Scalars['BigInt']['output'];
  timestamp: Scalars['Int']['output'];
  tokenAmountIn: Scalars['BigDecimal']['output'];
  tokenAmountOut: Scalars['BigDecimal']['output'];
  tokenIn: Scalars['Bytes']['output'];
  tokenInSym: Scalars['String']['output'];
  tokenOut: Scalars['Bytes']['output'];
  tokenOutSym: Scalars['String']['output'];
  userAddress?: Maybe<User>;
  value: Scalars['BigDecimal']['output'];
};


export type SwapOperationPartialSwapsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SwapOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SwapFilter>;
};

export type SwapOperationFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<SwapOperationFilter>>>;
  caller?: InputMaybe<Scalars['Bytes']['input']>;
  caller_contains?: InputMaybe<Scalars['Bytes']['input']>;
  caller_gt?: InputMaybe<Scalars['Bytes']['input']>;
  caller_gte?: InputMaybe<Scalars['Bytes']['input']>;
  caller_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  caller_lt?: InputMaybe<Scalars['Bytes']['input']>;
  caller_lte?: InputMaybe<Scalars['Bytes']['input']>;
  caller_not?: InputMaybe<Scalars['Bytes']['input']>;
  caller_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  caller_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  feeValue?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeValue_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeValue_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeValue_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  feeValue_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeValue_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeValue_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeValue_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<SwapOperationFilter>>>;
  partialSwapIds?: InputMaybe<Array<Scalars['String']['input']>>;
  partialSwapIds_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  partialSwapIds_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  partialSwapIds_not?: InputMaybe<Array<Scalars['String']['input']>>;
  partialSwapIds_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  partialSwapIds_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  partialSwapsCount?: InputMaybe<Scalars['BigInt']['input']>;
  partialSwapsCount_gt?: InputMaybe<Scalars['BigInt']['input']>;
  partialSwapsCount_gte?: InputMaybe<Scalars['BigInt']['input']>;
  partialSwapsCount_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  partialSwapsCount_lt?: InputMaybe<Scalars['BigInt']['input']>;
  partialSwapsCount_lte?: InputMaybe<Scalars['BigInt']['input']>;
  partialSwapsCount_not?: InputMaybe<Scalars['BigInt']['input']>;
  partialSwapsCount_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  partialSwaps_?: InputMaybe<SwapFilter>;
  timestamp?: InputMaybe<Scalars['Int']['input']>;
  timestamp_gt?: InputMaybe<Scalars['Int']['input']>;
  timestamp_gte?: InputMaybe<Scalars['Int']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['Int']['input']>;
  timestamp_lte?: InputMaybe<Scalars['Int']['input']>;
  timestamp_not?: InputMaybe<Scalars['Int']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  tokenAmountIn?: InputMaybe<Scalars['BigDecimal']['input']>;
  tokenAmountIn_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  tokenAmountIn_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  tokenAmountIn_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  tokenAmountIn_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  tokenAmountIn_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  tokenAmountIn_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  tokenAmountIn_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  tokenAmountOut?: InputMaybe<Scalars['BigDecimal']['input']>;
  tokenAmountOut_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  tokenAmountOut_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  tokenAmountOut_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  tokenAmountOut_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  tokenAmountOut_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  tokenAmountOut_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  tokenAmountOut_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  tokenIn?: InputMaybe<Scalars['Bytes']['input']>;
  tokenInSym?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_contains?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_gt?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_gte?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenInSym_lt?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_lte?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_not?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_not_contains?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenInSym_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenIn_contains?: InputMaybe<Scalars['Bytes']['input']>;
  tokenIn_gt?: InputMaybe<Scalars['Bytes']['input']>;
  tokenIn_gte?: InputMaybe<Scalars['Bytes']['input']>;
  tokenIn_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  tokenIn_lt?: InputMaybe<Scalars['Bytes']['input']>;
  tokenIn_lte?: InputMaybe<Scalars['Bytes']['input']>;
  tokenIn_not?: InputMaybe<Scalars['Bytes']['input']>;
  tokenIn_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  tokenIn_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  tokenOut?: InputMaybe<Scalars['Bytes']['input']>;
  tokenOutSym?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_contains?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_gt?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_gte?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenOutSym_lt?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_lte?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_not?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_not_contains?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenOutSym_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenOut_contains?: InputMaybe<Scalars['Bytes']['input']>;
  tokenOut_gt?: InputMaybe<Scalars['Bytes']['input']>;
  tokenOut_gte?: InputMaybe<Scalars['Bytes']['input']>;
  tokenOut_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  tokenOut_lt?: InputMaybe<Scalars['Bytes']['input']>;
  tokenOut_lte?: InputMaybe<Scalars['Bytes']['input']>;
  tokenOut_not?: InputMaybe<Scalars['Bytes']['input']>;
  tokenOut_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  tokenOut_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  userAddress?: InputMaybe<Scalars['String']['input']>;
  userAddress_?: InputMaybe<UserFilter>;
  userAddress_contains?: InputMaybe<Scalars['String']['input']>;
  userAddress_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  userAddress_ends_with?: InputMaybe<Scalars['String']['input']>;
  userAddress_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  userAddress_gt?: InputMaybe<Scalars['String']['input']>;
  userAddress_gte?: InputMaybe<Scalars['String']['input']>;
  userAddress_in?: InputMaybe<Array<Scalars['String']['input']>>;
  userAddress_lt?: InputMaybe<Scalars['String']['input']>;
  userAddress_lte?: InputMaybe<Scalars['String']['input']>;
  userAddress_not?: InputMaybe<Scalars['String']['input']>;
  userAddress_not_contains?: InputMaybe<Scalars['String']['input']>;
  userAddress_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  userAddress_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  userAddress_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  userAddress_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  userAddress_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  userAddress_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  userAddress_starts_with?: InputMaybe<Scalars['String']['input']>;
  userAddress_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['BigDecimal']['input']>;
  value_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  value_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  value_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  value_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  value_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  value_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  value_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
};

export enum SwapOperationOrderBy {
  Caller = 'caller',
  FeeValue = 'feeValue',
  Id = 'id',
  PartialSwapIds = 'partialSwapIds',
  PartialSwaps = 'partialSwaps',
  PartialSwapsCount = 'partialSwapsCount',
  Timestamp = 'timestamp',
  TokenAmountIn = 'tokenAmountIn',
  TokenAmountOut = 'tokenAmountOut',
  TokenIn = 'tokenIn',
  TokenInSym = 'tokenInSym',
  TokenOut = 'tokenOut',
  TokenOutSym = 'tokenOutSym',
  UserAddress = 'userAddress',
  UserAddressId = 'userAddress__id',
  UserAddressProxyAddress = 'userAddress__proxyAddress',
  Value = 'value'
}

export type SwapFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<SwapFilter>>>;
  caller?: InputMaybe<Scalars['Bytes']['input']>;
  caller_contains?: InputMaybe<Scalars['Bytes']['input']>;
  caller_gt?: InputMaybe<Scalars['Bytes']['input']>;
  caller_gte?: InputMaybe<Scalars['Bytes']['input']>;
  caller_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  caller_lt?: InputMaybe<Scalars['Bytes']['input']>;
  caller_lte?: InputMaybe<Scalars['Bytes']['input']>;
  caller_not?: InputMaybe<Scalars['Bytes']['input']>;
  caller_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  caller_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  feeValue?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeValue_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeValue_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeValue_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  feeValue_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeValue_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeValue_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  feeValue_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<SwapFilter>>>;
  poolAddress?: InputMaybe<Scalars['String']['input']>;
  poolAddress_?: InputMaybe<PoolFilter>;
  poolAddress_contains?: InputMaybe<Scalars['String']['input']>;
  poolAddress_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  poolAddress_ends_with?: InputMaybe<Scalars['String']['input']>;
  poolAddress_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolAddress_gt?: InputMaybe<Scalars['String']['input']>;
  poolAddress_gte?: InputMaybe<Scalars['String']['input']>;
  poolAddress_in?: InputMaybe<Array<Scalars['String']['input']>>;
  poolAddress_lt?: InputMaybe<Scalars['String']['input']>;
  poolAddress_lte?: InputMaybe<Scalars['String']['input']>;
  poolAddress_not?: InputMaybe<Scalars['String']['input']>;
  poolAddress_not_contains?: InputMaybe<Scalars['String']['input']>;
  poolAddress_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  poolAddress_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  poolAddress_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolAddress_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  poolAddress_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  poolAddress_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolAddress_starts_with?: InputMaybe<Scalars['String']['input']>;
  poolAddress_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolLiquidity?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolLiquidity_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolLiquidity_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolLiquidity_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  poolLiquidity_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolLiquidity_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolLiquidity_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolLiquidity_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  poolTotalSwapFee?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolTotalSwapFee_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolTotalSwapFee_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolTotalSwapFee_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  poolTotalSwapFee_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolTotalSwapFee_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolTotalSwapFee_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolTotalSwapFee_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  poolTotalSwapVolume?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolTotalSwapVolume_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolTotalSwapVolume_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolTotalSwapVolume_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  poolTotalSwapVolume_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolTotalSwapVolume_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolTotalSwapVolume_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolTotalSwapVolume_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  swapOperation?: InputMaybe<Scalars['String']['input']>;
  swapOperation_?: InputMaybe<SwapOperationFilter>;
  swapOperation_contains?: InputMaybe<Scalars['String']['input']>;
  swapOperation_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  swapOperation_ends_with?: InputMaybe<Scalars['String']['input']>;
  swapOperation_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  swapOperation_gt?: InputMaybe<Scalars['String']['input']>;
  swapOperation_gte?: InputMaybe<Scalars['String']['input']>;
  swapOperation_in?: InputMaybe<Array<Scalars['String']['input']>>;
  swapOperation_lt?: InputMaybe<Scalars['String']['input']>;
  swapOperation_lte?: InputMaybe<Scalars['String']['input']>;
  swapOperation_not?: InputMaybe<Scalars['String']['input']>;
  swapOperation_not_contains?: InputMaybe<Scalars['String']['input']>;
  swapOperation_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  swapOperation_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  swapOperation_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  swapOperation_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  swapOperation_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  swapOperation_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  swapOperation_starts_with?: InputMaybe<Scalars['String']['input']>;
  swapOperation_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['Int']['input']>;
  timestamp_gt?: InputMaybe<Scalars['Int']['input']>;
  timestamp_gte?: InputMaybe<Scalars['Int']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['Int']['input']>;
  timestamp_lte?: InputMaybe<Scalars['Int']['input']>;
  timestamp_not?: InputMaybe<Scalars['Int']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  tokenAmountIn?: InputMaybe<Scalars['BigDecimal']['input']>;
  tokenAmountIn_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  tokenAmountIn_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  tokenAmountIn_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  tokenAmountIn_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  tokenAmountIn_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  tokenAmountIn_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  tokenAmountIn_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  tokenAmountOut?: InputMaybe<Scalars['BigDecimal']['input']>;
  tokenAmountOut_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  tokenAmountOut_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  tokenAmountOut_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  tokenAmountOut_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  tokenAmountOut_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  tokenAmountOut_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  tokenAmountOut_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  tokenIn?: InputMaybe<Scalars['Bytes']['input']>;
  tokenInSym?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_contains?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_gt?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_gte?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenInSym_lt?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_lte?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_not?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_not_contains?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenInSym_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenInSym_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenIn_contains?: InputMaybe<Scalars['Bytes']['input']>;
  tokenIn_gt?: InputMaybe<Scalars['Bytes']['input']>;
  tokenIn_gte?: InputMaybe<Scalars['Bytes']['input']>;
  tokenIn_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  tokenIn_lt?: InputMaybe<Scalars['Bytes']['input']>;
  tokenIn_lte?: InputMaybe<Scalars['Bytes']['input']>;
  tokenIn_not?: InputMaybe<Scalars['Bytes']['input']>;
  tokenIn_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  tokenIn_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  tokenOut?: InputMaybe<Scalars['Bytes']['input']>;
  tokenOutSym?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_contains?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_gt?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_gte?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenOutSym_lt?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_lte?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_not?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_not_contains?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenOutSym_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_starts_with?: InputMaybe<Scalars['String']['input']>;
  tokenOutSym_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tokenOut_contains?: InputMaybe<Scalars['Bytes']['input']>;
  tokenOut_gt?: InputMaybe<Scalars['Bytes']['input']>;
  tokenOut_gte?: InputMaybe<Scalars['Bytes']['input']>;
  tokenOut_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  tokenOut_lt?: InputMaybe<Scalars['Bytes']['input']>;
  tokenOut_lte?: InputMaybe<Scalars['Bytes']['input']>;
  tokenOut_not?: InputMaybe<Scalars['Bytes']['input']>;
  tokenOut_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  tokenOut_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  userAddress?: InputMaybe<Scalars['String']['input']>;
  userAddress_?: InputMaybe<UserFilter>;
  userAddress_contains?: InputMaybe<Scalars['String']['input']>;
  userAddress_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  userAddress_ends_with?: InputMaybe<Scalars['String']['input']>;
  userAddress_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  userAddress_gt?: InputMaybe<Scalars['String']['input']>;
  userAddress_gte?: InputMaybe<Scalars['String']['input']>;
  userAddress_in?: InputMaybe<Array<Scalars['String']['input']>>;
  userAddress_lt?: InputMaybe<Scalars['String']['input']>;
  userAddress_lte?: InputMaybe<Scalars['String']['input']>;
  userAddress_not?: InputMaybe<Scalars['String']['input']>;
  userAddress_not_contains?: InputMaybe<Scalars['String']['input']>;
  userAddress_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  userAddress_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  userAddress_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  userAddress_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  userAddress_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  userAddress_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  userAddress_starts_with?: InputMaybe<Scalars['String']['input']>;
  userAddress_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['BigDecimal']['input']>;
  value_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  value_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  value_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  value_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  value_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  value_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  value_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
};

export enum SwapOrderBy {
  Caller = 'caller',
  FeeValue = 'feeValue',
  Id = 'id',
  PoolAddress = 'poolAddress',
  PoolAddressActive = 'poolAddress__active',
  PoolAddressAddTokenTimeLockInBlocks = 'poolAddress__addTokenTimeLockInBlocks',
  PoolAddressCap = 'poolAddress__cap',
  PoolAddressController = 'poolAddress__controller',
  PoolAddressCreateTime = 'poolAddress__createTime',
  PoolAddressCrp = 'poolAddress__crp',
  PoolAddressCrpController = 'poolAddress__crpController',
  PoolAddressExitsCount = 'poolAddress__exitsCount',
  PoolAddressFinalized = 'poolAddress__finalized',
  PoolAddressHoldersCount = 'poolAddress__holdersCount',
  PoolAddressId = 'poolAddress__id',
  PoolAddressJoinsCount = 'poolAddress__joinsCount',
  PoolAddressLiquidity = 'poolAddress__liquidity',
  PoolAddressLogAddress = 'poolAddress__logAddress',
  PoolAddressMinimumWeightChangeBlockPeriod = 'poolAddress__minimumWeightChangeBlockPeriod',
  PoolAddressName = 'poolAddress__name',
  PoolAddressPublicSwap = 'poolAddress__publicSwap',
  PoolAddressSwapFee = 'poolAddress__swapFee',
  PoolAddressSwapsCount = 'poolAddress__swapsCount',
  PoolAddressSymbol = 'poolAddress__symbol',
  PoolAddressTokensCount = 'poolAddress__tokensCount',
  PoolAddressTotalShares = 'poolAddress__totalShares',
  PoolAddressTotalSwapFee = 'poolAddress__totalSwapFee',
  PoolAddressTotalSwapVolume = 'poolAddress__totalSwapVolume',
  PoolAddressTotalWeight = 'poolAddress__totalWeight',
  PoolAddressTx = 'poolAddress__tx',
  PoolLiquidity = 'poolLiquidity',
  PoolTotalSwapFee = 'poolTotalSwapFee',
  PoolTotalSwapVolume = 'poolTotalSwapVolume',
  SwapOperation = 'swapOperation',
  SwapOperationCaller = 'swapOperation__caller',
  SwapOperationFeeValue = 'swapOperation__feeValue',
  SwapOperationId = 'swapOperation__id',
  SwapOperationPartialSwapsCount = 'swapOperation__partialSwapsCount',
  SwapOperationTimestamp = 'swapOperation__timestamp',
  SwapOperationTokenAmountIn = 'swapOperation__tokenAmountIn',
  SwapOperationTokenAmountOut = 'swapOperation__tokenAmountOut',
  SwapOperationTokenIn = 'swapOperation__tokenIn',
  SwapOperationTokenInSym = 'swapOperation__tokenInSym',
  SwapOperationTokenOut = 'swapOperation__tokenOut',
  SwapOperationTokenOutSym = 'swapOperation__tokenOutSym',
  SwapOperationValue = 'swapOperation__value',
  Timestamp = 'timestamp',
  TokenAmountIn = 'tokenAmountIn',
  TokenAmountOut = 'tokenAmountOut',
  TokenIn = 'tokenIn',
  TokenInSym = 'tokenInSym',
  TokenOut = 'tokenOut',
  TokenOutSym = 'tokenOutSym',
  UserAddress = 'userAddress',
  UserAddressId = 'userAddress__id',
  UserAddressProxyAddress = 'userAddress__proxyAddress',
  Value = 'value'
}

export type SwarmStake = {
  __typename?: 'SwarmStake';
  id: Scalars['ID']['output'];
  maker: Scalars['Bytes']['output'];
  /** (Un)Staked amount in SMT */
  stakedAmount: Scalars['BigDecimal']['output'];
  stakedAt: Scalars['Int']['output'];
  /** Could be any security security added to the contract */
  stakedSecurity: Security;
  stakedTx: Scalars['Bytes']['output'];
  unstaked: Scalars['Boolean']['output'];
  unstakedAt: Scalars['Int']['output'];
};

export type SwarmStakeFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<SwarmStakeFilter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  maker?: InputMaybe<Scalars['Bytes']['input']>;
  maker_contains?: InputMaybe<Scalars['Bytes']['input']>;
  maker_gt?: InputMaybe<Scalars['Bytes']['input']>;
  maker_gte?: InputMaybe<Scalars['Bytes']['input']>;
  maker_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  maker_lt?: InputMaybe<Scalars['Bytes']['input']>;
  maker_lte?: InputMaybe<Scalars['Bytes']['input']>;
  maker_not?: InputMaybe<Scalars['Bytes']['input']>;
  maker_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  maker_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  or?: InputMaybe<Array<InputMaybe<SwarmStakeFilter>>>;
  stakedAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
  stakedAmount_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  stakedAmount_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  stakedAmount_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  stakedAmount_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  stakedAmount_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  stakedAmount_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  stakedAmount_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  stakedAt?: InputMaybe<Scalars['Int']['input']>;
  stakedAt_gt?: InputMaybe<Scalars['Int']['input']>;
  stakedAt_gte?: InputMaybe<Scalars['Int']['input']>;
  stakedAt_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  stakedAt_lt?: InputMaybe<Scalars['Int']['input']>;
  stakedAt_lte?: InputMaybe<Scalars['Int']['input']>;
  stakedAt_not?: InputMaybe<Scalars['Int']['input']>;
  stakedAt_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  stakedSecurity?: InputMaybe<Scalars['String']['input']>;
  stakedSecurity_?: InputMaybe<SecurityFilter>;
  stakedSecurity_contains?: InputMaybe<Scalars['String']['input']>;
  stakedSecurity_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  stakedSecurity_ends_with?: InputMaybe<Scalars['String']['input']>;
  stakedSecurity_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  stakedSecurity_gt?: InputMaybe<Scalars['String']['input']>;
  stakedSecurity_gte?: InputMaybe<Scalars['String']['input']>;
  stakedSecurity_in?: InputMaybe<Array<Scalars['String']['input']>>;
  stakedSecurity_lt?: InputMaybe<Scalars['String']['input']>;
  stakedSecurity_lte?: InputMaybe<Scalars['String']['input']>;
  stakedSecurity_not?: InputMaybe<Scalars['String']['input']>;
  stakedSecurity_not_contains?: InputMaybe<Scalars['String']['input']>;
  stakedSecurity_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  stakedSecurity_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  stakedSecurity_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  stakedSecurity_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  stakedSecurity_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  stakedSecurity_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  stakedSecurity_starts_with?: InputMaybe<Scalars['String']['input']>;
  stakedSecurity_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  stakedTx?: InputMaybe<Scalars['Bytes']['input']>;
  stakedTx_contains?: InputMaybe<Scalars['Bytes']['input']>;
  stakedTx_gt?: InputMaybe<Scalars['Bytes']['input']>;
  stakedTx_gte?: InputMaybe<Scalars['Bytes']['input']>;
  stakedTx_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  stakedTx_lt?: InputMaybe<Scalars['Bytes']['input']>;
  stakedTx_lte?: InputMaybe<Scalars['Bytes']['input']>;
  stakedTx_not?: InputMaybe<Scalars['Bytes']['input']>;
  stakedTx_not_contains?: InputMaybe<Scalars['Bytes']['input']>;
  stakedTx_not_in?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  unstaked?: InputMaybe<Scalars['Boolean']['input']>;
  unstakedAt?: InputMaybe<Scalars['Int']['input']>;
  unstakedAt_gt?: InputMaybe<Scalars['Int']['input']>;
  unstakedAt_gte?: InputMaybe<Scalars['Int']['input']>;
  unstakedAt_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  unstakedAt_lt?: InputMaybe<Scalars['Int']['input']>;
  unstakedAt_lte?: InputMaybe<Scalars['Int']['input']>;
  unstakedAt_not?: InputMaybe<Scalars['Int']['input']>;
  unstakedAt_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  unstaked_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  unstaked_not?: InputMaybe<Scalars['Boolean']['input']>;
  unstaked_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export enum SwarmStakeOrderBy {
  Id = 'id',
  Maker = 'maker',
  StakedAmount = 'stakedAmount',
  StakedAt = 'stakedAt',
  StakedSecurity = 'stakedSecurity',
  StakedSecurityId = 'stakedSecurity__id',
  StakedSecuritySender = 'stakedSecurity__sender',
  StakedSecuritySmtStaked = 'stakedSecurity__smtStaked',
  StakedTx = 'stakedTx',
  Unstaked = 'unstaked',
  UnstakedAt = 'unstakedAt'
}

export type Token = {
  __typename?: 'Token';
  decimals: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isLPT: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  paused: Scalars['Boolean']['output'];
  symbol: Scalars['String']['output'];
  tvl: Scalars['BigDecimal']['output'];
  xToken: XToken;
};

export type TokenPrice = {
  __typename?: 'TokenPrice';
  decimals: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  poolLiquidity?: Maybe<Scalars['BigDecimal']['output']>;
  poolTokenId?: Maybe<Scalars['String']['output']>;
  price: Scalars['BigDecimal']['output'];
  symbol: Scalars['String']['output'];
};

export type TokenPriceFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<TokenPriceFilter>>>;
  decimals?: InputMaybe<Scalars['Int']['input']>;
  decimals_gt?: InputMaybe<Scalars['Int']['input']>;
  decimals_gte?: InputMaybe<Scalars['Int']['input']>;
  decimals_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  decimals_lt?: InputMaybe<Scalars['Int']['input']>;
  decimals_lte?: InputMaybe<Scalars['Int']['input']>;
  decimals_not?: InputMaybe<Scalars['Int']['input']>;
  decimals_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<TokenPriceFilter>>>;
  poolLiquidity?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolLiquidity_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolLiquidity_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolLiquidity_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  poolLiquidity_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolLiquidity_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolLiquidity_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  poolLiquidity_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  poolTokenId?: InputMaybe<Scalars['String']['input']>;
  poolTokenId_contains?: InputMaybe<Scalars['String']['input']>;
  poolTokenId_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  poolTokenId_ends_with?: InputMaybe<Scalars['String']['input']>;
  poolTokenId_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolTokenId_gt?: InputMaybe<Scalars['String']['input']>;
  poolTokenId_gte?: InputMaybe<Scalars['String']['input']>;
  poolTokenId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  poolTokenId_lt?: InputMaybe<Scalars['String']['input']>;
  poolTokenId_lte?: InputMaybe<Scalars['String']['input']>;
  poolTokenId_not?: InputMaybe<Scalars['String']['input']>;
  poolTokenId_not_contains?: InputMaybe<Scalars['String']['input']>;
  poolTokenId_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  poolTokenId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  poolTokenId_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolTokenId_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  poolTokenId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  poolTokenId_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  poolTokenId_starts_with?: InputMaybe<Scalars['String']['input']>;
  poolTokenId_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['BigDecimal']['input']>;
  price_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  price_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  price_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  price_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  price_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  price_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  price_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  symbol_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_gt?: InputMaybe<Scalars['String']['input']>;
  symbol_gte?: InputMaybe<Scalars['String']['input']>;
  symbol_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_lt?: InputMaybe<Scalars['String']['input']>;
  symbol_lte?: InputMaybe<Scalars['String']['input']>;
  symbol_not?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum TokenPriceOrderBy {
  Decimals = 'decimals',
  Id = 'id',
  Name = 'name',
  PoolLiquidity = 'poolLiquidity',
  PoolTokenId = 'poolTokenId',
  Price = 'price',
  Symbol = 'symbol'
}

export type TokenFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<TokenFilter>>>;
  decimals?: InputMaybe<Scalars['Int']['input']>;
  decimals_gt?: InputMaybe<Scalars['Int']['input']>;
  decimals_gte?: InputMaybe<Scalars['Int']['input']>;
  decimals_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  decimals_lt?: InputMaybe<Scalars['Int']['input']>;
  decimals_lte?: InputMaybe<Scalars['Int']['input']>;
  decimals_not?: InputMaybe<Scalars['Int']['input']>;
  decimals_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isLPT?: InputMaybe<Scalars['Boolean']['input']>;
  isLPT_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isLPT_not?: InputMaybe<Scalars['Boolean']['input']>;
  isLPT_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<TokenFilter>>>;
  paused?: InputMaybe<Scalars['Boolean']['input']>;
  paused_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  paused_not?: InputMaybe<Scalars['Boolean']['input']>;
  paused_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  symbol_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_gt?: InputMaybe<Scalars['String']['input']>;
  symbol_gte?: InputMaybe<Scalars['String']['input']>;
  symbol_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_lt?: InputMaybe<Scalars['String']['input']>;
  symbol_lte?: InputMaybe<Scalars['String']['input']>;
  symbol_not?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  tvl?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  tvl_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  tvl_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  xToken?: InputMaybe<Scalars['String']['input']>;
  xToken_?: InputMaybe<XTokenFilter>;
  xToken_contains?: InputMaybe<Scalars['String']['input']>;
  xToken_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  xToken_ends_with?: InputMaybe<Scalars['String']['input']>;
  xToken_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  xToken_gt?: InputMaybe<Scalars['String']['input']>;
  xToken_gte?: InputMaybe<Scalars['String']['input']>;
  xToken_in?: InputMaybe<Array<Scalars['String']['input']>>;
  xToken_lt?: InputMaybe<Scalars['String']['input']>;
  xToken_lte?: InputMaybe<Scalars['String']['input']>;
  xToken_not?: InputMaybe<Scalars['String']['input']>;
  xToken_not_contains?: InputMaybe<Scalars['String']['input']>;
  xToken_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  xToken_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  xToken_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  xToken_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  xToken_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  xToken_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  xToken_starts_with?: InputMaybe<Scalars['String']['input']>;
  xToken_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum TokenOrderBy {
  Decimals = 'decimals',
  Id = 'id',
  IsLpt = 'isLPT',
  Name = 'name',
  Paused = 'paused',
  Symbol = 'symbol',
  Tvl = 'tvl',
  XToken = 'xToken',
  XTokenDecimals = 'xToken__decimals',
  XTokenId = 'xToken__id',
  XTokenIsLpt = 'xToken__isLPT',
  XTokenName = 'xToken__name',
  XTokenPaused = 'xToken__paused',
  XTokenSymbol = 'xToken__symbol'
}

export type Transaction = {
  __typename?: 'Transaction';
  action?: Maybe<TransactionType>;
  block: Scalars['Int']['output'];
  gasPrice: Scalars['BigDecimal']['output'];
  gasUsed: Scalars['BigDecimal']['output'];
  id: Scalars['ID']['output'];
  pools: Array<Pool>;
  timestamp: Scalars['Int']['output'];
  tokenAmountsIn: Array<Scalars['BigDecimal']['output']>;
  tokenAmountsOut: Array<Scalars['BigDecimal']['output']>;
  tokensIn: Array<XToken>;
  tokensInAddresses: Array<Scalars['Bytes']['output']>;
  tokensOut: Array<XToken>;
  tokensOutAddresses: Array<Scalars['Bytes']['output']>;
  userAddress?: Maybe<User>;
  value: Scalars['BigDecimal']['output'];
};


export type TransactionPoolsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PoolFilter>;
};


export type TransactionTokensInArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<XTokenOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<XTokenFilter>;
};


export type TransactionTokensOutArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<XTokenOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<XTokenFilter>;
};

export enum TransactionType {
  CreatePool = 'createPool',
  ExitPool = 'exitPool',
  ExitPoolSingleOut = 'exitPoolSingleOut',
  JoinPool = 'joinPool',
  JoinPoolSingleIn = 'joinPoolSingleIn',
  Swap = 'swap'
}

export type TransactionFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  action?: InputMaybe<TransactionType>;
  action_in?: InputMaybe<Array<TransactionType>>;
  action_not?: InputMaybe<TransactionType>;
  action_not_in?: InputMaybe<Array<TransactionType>>;
  and?: InputMaybe<Array<InputMaybe<TransactionFilter>>>;
  block?: InputMaybe<Scalars['Int']['input']>;
  block_gt?: InputMaybe<Scalars['Int']['input']>;
  block_gte?: InputMaybe<Scalars['Int']['input']>;
  block_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  block_lt?: InputMaybe<Scalars['Int']['input']>;
  block_lte?: InputMaybe<Scalars['Int']['input']>;
  block_not?: InputMaybe<Scalars['Int']['input']>;
  block_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  gasPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  gasPrice_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  gasPrice_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  gasPrice_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  gasPrice_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  gasPrice_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  gasPrice_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  gasPrice_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  gasUsed?: InputMaybe<Scalars['BigDecimal']['input']>;
  gasUsed_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  gasUsed_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  gasUsed_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  gasUsed_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  gasUsed_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  gasUsed_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  gasUsed_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<TransactionFilter>>>;
  pools?: InputMaybe<Array<Scalars['String']['input']>>;
  pools_?: InputMaybe<PoolFilter>;
  pools_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  pools_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  pools_not?: InputMaybe<Array<Scalars['String']['input']>>;
  pools_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  pools_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  timestamp?: InputMaybe<Scalars['Int']['input']>;
  timestamp_gt?: InputMaybe<Scalars['Int']['input']>;
  timestamp_gte?: InputMaybe<Scalars['Int']['input']>;
  timestamp_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  timestamp_lt?: InputMaybe<Scalars['Int']['input']>;
  timestamp_lte?: InputMaybe<Scalars['Int']['input']>;
  timestamp_not?: InputMaybe<Scalars['Int']['input']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  tokenAmountsIn?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  tokenAmountsIn_contains?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  tokenAmountsIn_contains_nocase?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  tokenAmountsIn_not?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  tokenAmountsIn_not_contains?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  tokenAmountsIn_not_contains_nocase?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  tokenAmountsOut?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  tokenAmountsOut_contains?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  tokenAmountsOut_contains_nocase?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  tokenAmountsOut_not?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  tokenAmountsOut_not_contains?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  tokenAmountsOut_not_contains_nocase?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  tokensIn?: InputMaybe<Array<Scalars['String']['input']>>;
  tokensInAddresses?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  tokensInAddresses_contains?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  tokensInAddresses_contains_nocase?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  tokensInAddresses_not?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  tokensInAddresses_not_contains?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  tokensInAddresses_not_contains_nocase?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  tokensIn_?: InputMaybe<XTokenFilter>;
  tokensIn_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  tokensIn_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  tokensIn_not?: InputMaybe<Array<Scalars['String']['input']>>;
  tokensIn_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  tokensIn_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  tokensOut?: InputMaybe<Array<Scalars['String']['input']>>;
  tokensOutAddresses?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  tokensOutAddresses_contains?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  tokensOutAddresses_contains_nocase?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  tokensOutAddresses_not?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  tokensOutAddresses_not_contains?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  tokensOutAddresses_not_contains_nocase?: InputMaybe<Array<Scalars['Bytes']['input']>>;
  tokensOut_?: InputMaybe<XTokenFilter>;
  tokensOut_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  tokensOut_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  tokensOut_not?: InputMaybe<Array<Scalars['String']['input']>>;
  tokensOut_not_contains?: InputMaybe<Array<Scalars['String']['input']>>;
  tokensOut_not_contains_nocase?: InputMaybe<Array<Scalars['String']['input']>>;
  userAddress?: InputMaybe<Scalars['String']['input']>;
  userAddress_?: InputMaybe<UserFilter>;
  userAddress_contains?: InputMaybe<Scalars['String']['input']>;
  userAddress_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  userAddress_ends_with?: InputMaybe<Scalars['String']['input']>;
  userAddress_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  userAddress_gt?: InputMaybe<Scalars['String']['input']>;
  userAddress_gte?: InputMaybe<Scalars['String']['input']>;
  userAddress_in?: InputMaybe<Array<Scalars['String']['input']>>;
  userAddress_lt?: InputMaybe<Scalars['String']['input']>;
  userAddress_lte?: InputMaybe<Scalars['String']['input']>;
  userAddress_not?: InputMaybe<Scalars['String']['input']>;
  userAddress_not_contains?: InputMaybe<Scalars['String']['input']>;
  userAddress_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  userAddress_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  userAddress_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  userAddress_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  userAddress_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  userAddress_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  userAddress_starts_with?: InputMaybe<Scalars['String']['input']>;
  userAddress_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['BigDecimal']['input']>;
  value_gt?: InputMaybe<Scalars['BigDecimal']['input']>;
  value_gte?: InputMaybe<Scalars['BigDecimal']['input']>;
  value_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  value_lt?: InputMaybe<Scalars['BigDecimal']['input']>;
  value_lte?: InputMaybe<Scalars['BigDecimal']['input']>;
  value_not?: InputMaybe<Scalars['BigDecimal']['input']>;
  value_not_in?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
};

export enum TransactionOrderBy {
  Action = 'action',
  Block = 'block',
  GasPrice = 'gasPrice',
  GasUsed = 'gasUsed',
  Id = 'id',
  Pools = 'pools',
  Timestamp = 'timestamp',
  TokenAmountsIn = 'tokenAmountsIn',
  TokenAmountsOut = 'tokenAmountsOut',
  TokensIn = 'tokensIn',
  TokensInAddresses = 'tokensInAddresses',
  TokensOut = 'tokensOut',
  TokensOutAddresses = 'tokensOutAddresses',
  UserAddress = 'userAddress',
  UserAddressId = 'userAddress__id',
  UserAddressProxyAddress = 'userAddress__proxyAddress',
  Value = 'value'
}

export type User = {
  __typename?: 'User';
  id: Scalars['ID']['output'];
  proxyAddress?: Maybe<Scalars['String']['output']>;
  sharesOwned?: Maybe<Array<PoolShare>>;
  swaps?: Maybe<Array<Swap>>;
  txs?: Maybe<Array<Transaction>>;
};


export type UserSharesOwnedArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolShareOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PoolShareFilter>;
};


export type UserSwapsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SwapOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SwapFilter>;
};


export type UserTxsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TransactionOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransactionFilter>;
};

export type UserFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<UserFilter>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  or?: InputMaybe<Array<InputMaybe<UserFilter>>>;
  proxyAddress?: InputMaybe<Scalars['String']['input']>;
  proxyAddress_contains?: InputMaybe<Scalars['String']['input']>;
  proxyAddress_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  proxyAddress_ends_with?: InputMaybe<Scalars['String']['input']>;
  proxyAddress_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  proxyAddress_gt?: InputMaybe<Scalars['String']['input']>;
  proxyAddress_gte?: InputMaybe<Scalars['String']['input']>;
  proxyAddress_in?: InputMaybe<Array<Scalars['String']['input']>>;
  proxyAddress_lt?: InputMaybe<Scalars['String']['input']>;
  proxyAddress_lte?: InputMaybe<Scalars['String']['input']>;
  proxyAddress_not?: InputMaybe<Scalars['String']['input']>;
  proxyAddress_not_contains?: InputMaybe<Scalars['String']['input']>;
  proxyAddress_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  proxyAddress_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  proxyAddress_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  proxyAddress_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  proxyAddress_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  proxyAddress_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  proxyAddress_starts_with?: InputMaybe<Scalars['String']['input']>;
  proxyAddress_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  sharesOwned_?: InputMaybe<PoolShareFilter>;
  swaps_?: InputMaybe<SwapFilter>;
  txs_?: InputMaybe<TransactionFilter>;
};

export enum UserOrderBy {
  Id = 'id',
  ProxyAddress = 'proxyAddress',
  SharesOwned = 'sharesOwned',
  Swaps = 'swaps',
  Txs = 'txs'
}

export type XToken = {
  __typename?: 'XToken';
  decimals: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isLPT: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  paused: Scalars['Boolean']['output'];
  poolTokens?: Maybe<Array<PoolToken>>;
  symbol: Scalars['String']['output'];
  token: Token;
};


export type XTokenPoolTokensArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PoolTokenOrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PoolTokenFilter>;
};

export type XTokenFilter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<XTokenFilter>>>;
  decimals?: InputMaybe<Scalars['Int']['input']>;
  decimals_gt?: InputMaybe<Scalars['Int']['input']>;
  decimals_gte?: InputMaybe<Scalars['Int']['input']>;
  decimals_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  decimals_lt?: InputMaybe<Scalars['Int']['input']>;
  decimals_lte?: InputMaybe<Scalars['Int']['input']>;
  decimals_not?: InputMaybe<Scalars['Int']['input']>;
  decimals_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isLPT?: InputMaybe<Scalars['Boolean']['input']>;
  isLPT_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isLPT_not?: InputMaybe<Scalars['Boolean']['input']>;
  isLPT_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<InputMaybe<XTokenFilter>>>;
  paused?: InputMaybe<Scalars['Boolean']['input']>;
  paused_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  paused_not?: InputMaybe<Scalars['Boolean']['input']>;
  paused_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  poolTokens_?: InputMaybe<PoolTokenFilter>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  symbol_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_gt?: InputMaybe<Scalars['String']['input']>;
  symbol_gte?: InputMaybe<Scalars['String']['input']>;
  symbol_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_lt?: InputMaybe<Scalars['String']['input']>;
  symbol_lte?: InputMaybe<Scalars['String']['input']>;
  symbol_not?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains?: InputMaybe<Scalars['String']['input']>;
  symbol_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  symbol_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with?: InputMaybe<Scalars['String']['input']>;
  symbol_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  token_?: InputMaybe<TokenFilter>;
  token_contains?: InputMaybe<Scalars['String']['input']>;
  token_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token_ends_with?: InputMaybe<Scalars['String']['input']>;
  token_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token_gt?: InputMaybe<Scalars['String']['input']>;
  token_gte?: InputMaybe<Scalars['String']['input']>;
  token_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token_lt?: InputMaybe<Scalars['String']['input']>;
  token_lte?: InputMaybe<Scalars['String']['input']>;
  token_not?: InputMaybe<Scalars['String']['input']>;
  token_not_contains?: InputMaybe<Scalars['String']['input']>;
  token_not_contains_nocase?: InputMaybe<Scalars['String']['input']>;
  token_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  token_not_ends_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  token_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  token_not_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
  token_starts_with?: InputMaybe<Scalars['String']['input']>;
  token_starts_with_nocase?: InputMaybe<Scalars['String']['input']>;
};

export enum XTokenOrderBy {
  Decimals = 'decimals',
  Id = 'id',
  IsLpt = 'isLPT',
  Name = 'name',
  Paused = 'paused',
  PoolTokens = 'poolTokens',
  Symbol = 'symbol',
  Token = 'token',
  TokenDecimals = 'token__decimals',
  TokenId = 'token__id',
  TokenIsLpt = 'token__isLPT',
  TokenName = 'token__name',
  TokenPaused = 'token__paused',
  TokenSymbol = 'token__symbol',
  TokenTvl = 'token__tvl'
}

export type Block = {
  __typename?: '_Block_';
  /** The hash of the block */
  hash?: Maybe<Scalars['Bytes']['output']>;
  /** The block number */
  number: Scalars['Int']['output'];
  /** The hash of the parent block */
  parentHash?: Maybe<Scalars['Bytes']['output']>;
  /** Integer representation of the timestamp stored in blocks for the chain */
  timestamp?: Maybe<Scalars['Int']['output']>;
};

/** The type for the top-level _meta field */
export type Meta = {
  __typename?: '_Meta_';
  /**
   * Information about a specific subgraph block. The hash of the block
   * will be null if the _meta field has a block constraint that asks for
   * a block number. It will be filled if the _meta field has no block constraint
   * and therefore asks for the latest  block
   *
   */
  block: Block;
  /** The deployment ID */
  deployment: Scalars['String']['output'];
  /** If `true`, the subgraph encountered indexing errors at some past block */
  hasIndexingErrors: Scalars['Boolean']['output'];
};

export enum SubgraphErrorPolicy {
  /** Data will be returned even if the subgraph has indexing errors */
  Allow = 'allow',
  /** If the subgraph has indexing errors, data will be omitted. The default. */
  Deny = 'deny'
}

export type InvestAssetsQueryVariables = Exact<{
  filter?: InputMaybe<AssetTokenFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type InvestAssetsQuery = { __typename?: 'Query', assetTokens: Array<{ __typename?: 'AssetToken', id: string, name: string, symbol: string, decimals: number, kya: string, enabled: boolean, isOnSafeGuard: boolean, frozen: boolean }> };


export const InvestAssetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InvestAssets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssetToken_filter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetTokens"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}},{"kind":"Field","name":{"kind":"Name","value":"kya"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"isOnSafeGuard"}},{"kind":"Field","name":{"kind":"Name","value":"frozen"}}]}}]}}]} as unknown as DocumentNode<InvestAssetsQuery, InvestAssetsQueryVariables>;